var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGetintouch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 484.806,
    height: 292.166,
    viewBox: "0 0 484.806 292.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 484.806,
    height: 292.166,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(-718 -143.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M7182.33,20821.432h16.716l2.154,11.439h2.429v1.545H7184.15v-1.545H7185Z",
    transform: "translate(-6213 -20427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "translate(68 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M7374.1,20795.85h4.325l.792-2.248-.792-1.5-2.429-.957h-1.066l-1.355.957-1.057,1.5Z",
    transform: "translate(-6281 -20455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M-17863.512-4127.879l-.748-.7-2.922-2.727a1,1,0,0,1-.049-1.413,1,1,0,0,1,1.412-.049l2.174,2.027,4.738-5.333a1,1,0,0,1,1.412-.083,1,1,0,0,1,.084,1.412Z",
    transform: "translate(18765 4323.908)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M7206.662,20807.645l-1.642,1.27-.345.969.345,1.3.839,1.033,1.177.42h1.905l1.426-.721.586-.732.6-1.686v-3.234Z",
    transform: "translate(-6281 -20455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M7050.325,20825.563l-.813.959-.694,1.137v1.143l.41.7.756.82.9.457,1.427.377,1.138,2.793,3.286-2.437-1.528-1.84-1.125-2.008-.456-1.43-1.154-.963Z",
    transform: "translate(-6281 -20455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M7181.752,20620.211l-1.382,1.789-.318.32-2.216.123-1.018-.443-1.028-1.32-.3-1.34.138-.84.431-.707.664-.451.81-.422,1.38.422,3.273,2.061Z",
    transform: "translate(-6281 -20455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M7030.591,20619.053l.55.611.686,1.443-.133,1.9-.971,1.793-1.209.59,1.989,1.822-.361,1.023-1.382,1.119H7027.1l-1.166-.826-1.07-.742.671-3.447-.374-2.963,1.5-1.717,1.981-.93Z",
    transform: "translate(-6281 -20455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3269",
    "data-name": "Group 3269",
    transform: "translate(650 115.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3268",
    "data-name": "Group 3268",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1621.577,2347.821a16.976,16.976,0,0,0,16.988,16.967v26.7H1551.2v-26.7a16.977,16.977,0,0,0,0-33.954v-26.7h87.362v26.7a16.981,16.981,0,0,0-16.988,16.987",
    transform: "translate(-1413.543 -2099.653)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M3586.892,2347.821a16.976,16.976,0,0,0,16.988,16.967v26.7h-87.362v-26.7a16.977,16.977,0,0,0,0-33.954v-26.7h87.362v26.7a16.981,16.981,0,0,0-16.988,16.987",
    transform: "translate(-3204.449 -2099.653)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M637.136,1362.12a16.967,16.967,0,0,0,16.962,16.962v26.7H627.789a17.1,17.1,0,0,0-34.192,0H566.734v-26.7a16.974,16.974,0,1,0,0-33.948v-26.7H654.1v26.7a16.973,16.973,0,0,0-16.962,16.987",
    transform: "translate(-516.44 -1201.428)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M2620.111,1405.785H2593.8a17.1,17.1,0,0,0-34.192,0h-26.863v-26.7a16.974,16.974,0,1,0,0-33.948v-26.7h87.363Z",
    transform: "translate(-2307.982 -1201.428)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M236.7,2879.037a15.011,15.011,0,0,1-4.875-1.153c-2.864-1.077-7.534-3.414-13.523-8.437a23.085,23.085,0,0,1-6.307-8.663,34.457,34.457,0,0,1-2.468-9.463,44.541,44.541,0,0,1-.017-10.759.318.318,0,0,1,.454-.238c.665.327,16.355,8.1,21.989,15.678,2.962,3.986,4.187,9.96,4.693,14.269a59.927,59.927,0,0,1,.395,8.461.317.317,0,0,1-.31.3H236.7m-26.618-37.943a45.023,45.023,0,0,0,.077,10.166c.66,5.358,2.68,12.778,8.551,17.7,9.928,8.326,16.285,9.311,17.7,9.426.047-2.2.1-15.187-4.972-22.007-5.051-6.8-18.838-14-21.361-15.287",
    transform: "translate(-190.635 -2588.234)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M241.03,2882.767a.317.317,0,0,1-.278-.164,195.408,195.408,0,0,0-10.612-16.627c-6.1-8.516-15.08-20.422-15.17-20.541a.317.317,0,1,1,.506-.382c.09.119,9.078,12.031,15.179,20.554a195.944,195.944,0,0,1,10.651,16.689.317.317,0,0,1-.123.431.311.311,0,0,1-.154.04",
    transform: "translate(-195.835 -2592.457)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M274.305,3109.917a.317.317,0,0,1-.045-.631l11.848-1.729a.317.317,0,0,1,.092.628l-11.848,1.729a.3.3,0,0,1-.046,0",
    transform: "translate(-249.673 -2831.778)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M249.954,3056.931h-.016l-12.319-.61a.317.317,0,1,1,.031-.634l12.319.609a.317.317,0,0,1-.015.634",
    transform: "translate(-216.257 -2784.514)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M322.316,2917.8l-.036,0a.317.317,0,0,1-.28-.351l.765-6.777a.317.317,0,0,1,.63.071l-.765,6.777a.317.317,0,0,1-.315.281",
    transform: "translate(-293.423 -2652.112)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M356.219,2733.844a.316.316,0,0,1-.125-.025,28.946,28.946,0,0,1-5.234-3.064c-3.532-2.6-5.615-5.531-6.023-8.469-.969-6.976.708-11.363.78-11.547a.317.317,0,0,1,.456-.158c.238.14,5.852,3.48,8.68,8.185,2.841,4.727,1.825,14.386,1.78,14.8a.317.317,0,0,1-.315.283m-10.134-22.51a25.623,25.623,0,0,0-.619,10.864c.824,5.935,8.612,9.968,10.478,10.854.165-1.962.663-9.969-1.734-13.959-2.357-3.922-6.866-6.96-8.125-7.759",
    transform: "translate(-313.961 -2469.994)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M367.233,2734.963a.318.318,0,0,1-.289-.187l-10.037-22.223a.317.317,0,0,1,.578-.261l10.037,22.223a.318.318,0,0,1-.289.448",
    transform: "translate(-325.208 -2471.423)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M357.506,2849.4l-.037,0-6.005-.707a.317.317,0,0,1,.074-.63l6.005.708a.317.317,0,0,1-.037.632",
    transform: "translate(-320.018 -2595.314)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M404.512,2769.381a.309.309,0,0,1-.125-.026.317.317,0,0,1-.166-.417l1.886-4.381a.317.317,0,0,1,.583.251l-1.886,4.38a.317.317,0,0,1-.292.192",
    transform: "translate(-368.325 -2519.045)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1059.093,3176.186l-3.908,9.73-8.714-.036s-.415-.546.323-.9c.527-.251.977-.211,1.486-.468s3.714-7.936,3.714-7.936Z",
    transform: "translate(-953.497 -2894.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1052.9,3183.851h0l-8.714-.036a.222.222,0,0,1-.176-.088.818.818,0,0,1-.143-.647.909.909,0,0,1,.547-.586,3.433,3.433,0,0,1,.786-.246,2.847,2.847,0,0,0,.686-.215,66.473,66.473,0,0,0,3.619-7.828.223.223,0,0,1,.193-.137l7.1-.393a.222.222,0,0,1,.219.305l-3.908,9.73a.222.222,0,0,1-.207.139m-8.582-.481,8.432.035,3.721-9.265-6.609.366c-.195.463-.886,2.1-1.614,3.748-1.762,3.977-2.016,4.1-2.152,4.173a3.217,3.217,0,0,1-.8.257,3.01,3.01,0,0,0-.691.213c-.122.058-.274.155-.306.288a.317.317,0,0,0,.019.186",
    transform: "translate(-951.207 -2892.031)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1042.431,3252.182l9.423.043,1.316-3.441c-1.546.144-4.384,1.925-5.945,1.51-.9-.233-1.075-1.547-1.936-1.51a3.3,3.3,0,0,1-.9,1.739c-.552.307-1.04.266-1.609.563a.732.732,0,0,0-.35,1.1",
    transform: "translate(-949.807 -2960.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M894.448,3195.361l-9.523,2.027-2.091-8.46s.428-.536.949.095c.372.45.444.9.816,1.327s7.737-1.776,7.737-1.776Z",
    transform: "translate(-804.487 -2905.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M882.635,3195.323a.223.223,0,0,1-.216-.17l-2.092-8.459a.223.223,0,0,1,.042-.192.817.817,0,0,1,.594-.3.9.9,0,0,1,.7.388,3.429,3.429,0,0,1,.43.7,2.932,2.932,0,0,0,.36.594c.51.124,4.2-.819,7.527-1.817a.223.223,0,0,1,.277.147l2.113,6.788a.223.223,0,0,1-.166.284l-9.523,2.026a.2.2,0,0,1-.047.005m-1.843-8.608,2.008,8.123,9.073-1.931-1.975-6.344c-.538.159-2.024.593-3.524.989-3.91,1.031-4.1.815-4.233.657a3.217,3.217,0,0,1-.444-.714,3.03,3.03,0,0,0-.375-.618.532.532,0,0,0-.352-.226h0a.313.313,0,0,0-.175.064",
    transform: "translate(-802.198 -2903.32)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M880.255,3186.632l2.258,9.148,3.312-.94c-.517-1.464-2.59-2.405-2.569-4.021.007-.926.736-1.921.491-2.748-.761.125-1.3.166-1.4.055-.433-.46-.511-.944-.939-1.423a.732.732,0,0,0-1.148-.072",
    transform: "translate(-802.138 -2903.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1328.371,2869.684a3.561,3.561,0,0,1-2.255-.783,2.962,2.962,0,0,1-1.125-2.155,3.44,3.44,0,0,1,6.84-.358h0a3.285,3.285,0,0,1-3.257,3.291c-.068,0-.135.005-.2.005m.077-5.813c-.059,0-.119,0-.178,0a2.865,2.865,0,0,0-2.859,2.848,2.546,2.546,0,0,0,.971,1.851,3.159,3.159,0,0,0,2.17.684,2.866,2.866,0,0,0,2.86-2.849h0a2.845,2.845,0,0,0-2.963-2.539",
    transform: "translate(-1207.403 -2609.337)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1366.952,2898.687a.892.892,0,0,1-.928-.8.8.8,0,0,1,.253-.624,1.015,1.015,0,0,1,1.355-.029.791.791,0,0,1,.017,1.177.994.994,0,0,1-.641.272h-.055m.022-1.276h-.033a.575.575,0,0,0-.371.155.389.389,0,0,0-.126.3.483.483,0,0,0,.542.4.574.574,0,0,0,.371-.155.388.388,0,0,0,.126-.3h0a.382.382,0,0,0-.132-.264.564.564,0,0,0-.377-.137",
    transform: "translate(-1244.797 -2639.902)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1365.172,2916.122a.2.2,0,0,1-.056-.008.21.21,0,0,1-.135-.116c-.352-.78-1.176-2.615-1.2-2.811a.21.21,0,0,1,.415-.067c.043.17.64,1.521,1.069,2.477l2.8-1.93-1.54-2.066a.21.21,0,1,1,.337-.251l1.671,2.241a.21.21,0,0,1-.049.3l-3.191,2.2a.21.21,0,0,1-.119.037",
    transform: "translate(-1242.748 -2652.907)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1101.984,3050.176c-4.131,0-13.83-10.418-15.2-11.918l-10.7,10.566a.208.208,0,0,1-.17.06l-5.459-.578a.21.21,0,0,1-.148-.332l6.467-8.955c.239-.378,4.757-7.479,8.659-9.054,1.689-.682,5.966,1.356,12.712,6.057,4.985,3.474,9.551,7.189,9.6,7.226a.217.217,0,0,1,.042.046,4.436,4.436,0,0,1,.493,3.971c-.737,1.577-2.772,2.553-6.047,2.9a2.309,2.309,0,0,1-.235.012m-15.2-12.431h.006a.211.211,0,0,1,.15.069c.112.124,11.243,12.355,15.232,11.932,3.117-.33,5.038-1.224,5.71-2.657a4.039,4.039,0,0,0-.444-3.536c-.378-.307-4.77-3.858-9.547-7.188-8.246-5.747-11.247-6.44-12.312-6.01-3.8,1.534-8.418,8.821-8.464,8.894l-.008.011-6.259,8.667,5,.529,10.789-10.65a.209.209,0,0,1,.148-.061m-9.847,1.392h0Z",
    transform: "translate(-975.28 -2760.958)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1376.244,2945.579c.918-4.5-.781-6.664-2.239-7.7-2.091-1.481-2.889-.552-2.889-.552l3.693-2.873s.9-1.217,3.325.491,7.234,20.338,7.234,20.338-4.349,2.218-7.81,1.985a32.941,32.941,0,0,1-5.377-.724s3.144-6.465,4.063-10.969",
    transform: "translate(-1249.438 -2673.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M1375.93,2955.311c-.183,0-.365-.006-.545-.018a33.537,33.537,0,0,1-5.415-.73.21.21,0,0,1-.137-.3c.031-.065,3.143-6.493,4.046-10.919.877-4.3-.687-6.444-2.154-7.483-1.485-1.052-2.247-.812-2.506-.661l-.132.1a.21.21,0,0,1-.288-.3.856.856,0,0,1,.192-.155l3.512-2.732c.161-.189,1.2-1.215,3.594.471,2.464,1.733,7.12,19.694,7.316,20.457a.21.21,0,0,1-.108.24,19.311,19.311,0,0,1-7.375,2.025m-5.6-1.1a36.2,36.2,0,0,0,5.088.661c3.006.2,6.757-1.508,7.55-1.888-1.674-6.464-5.253-18.748-7.109-20.053-2.209-1.554-3-.579-3.037-.536a.237.237,0,0,1-.039.039l-2.847,2.215a4.155,4.155,0,0,1,2.036.872c1.569,1.112,3.246,3.386,2.323,7.91h0a58.278,58.278,0,0,1-3.966,10.78m3.76-10.822h0Z",
    transform: "translate(-1247.28 -2671.472)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M1331.161,2832.841c.255.156-.789-1.319-1.083-1.595-.523-.491-1.589-.752-1.978-1.316-.716-1.033-1.2-3.01.32-3.545,1.5-.528,1.708,1.654,2.785,1.944.817.22.6-1.054,1.285-1.038,2.282.053,3.126,3.483,3.087,5.207-.01.408-.844,2.507-1.535,2.176-.419-.2-1.633-.307-1.775-.656-.063-.156.311-.587.17-.934-.164-.4-1.644-.471-1.275-.244",
    transform: "translate(-1209.622 -2575.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M1070.919,2975.811l4.264,15.116,7.972-1.841,5.568-1.191-.258-1.189-7.119,1.675L1077.4,2975.8Z",
    transform: "translate(-975.882 -2711.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M1073.026,2988.981a.21.21,0,0,1-.2-.153l-4.264-15.116a.21.21,0,0,1,.2-.267l6.482-.007h0a.21.21,0,0,1,.2.147l3.887,12.391,6.929-1.63a.209.209,0,0,1,.253.16l.258,1.189a.21.21,0,0,1-.161.25l-5.568,1.191-7.969,1.84a.2.2,0,0,1-.047.006m-3.987-15.116,4.135,14.656,7.777-1.8,5.366-1.147-.168-.774-6.911,1.626a.21.21,0,0,1-.249-.142l-3.9-12.43Z",
    transform: "translate(-973.724 -2709.564)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M1195.02,2976.73l.953-2.92L1207.15,2975s1.239-13.8,4.7-13.263c7.621,1.18,4.264,16.415.057,20.165s-16.886-5.167-16.886-5.167",
    transform: "translate(-1088.969 -2698.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1238.589,3052.152l.444-3.49,8.629.437-.857,5.091Z",
    transform: "translate(-1128.672 -2778.113)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M1132.758,3096.262a6.041,6.041,0,0,0-2.661-.382,16.082,16.082,0,0,0-3.982,1.186c-.3.3,2.8.031,2.8.031a18.679,18.679,0,0,0-3.059,1.382,18.3,18.3,0,0,0,3.282-.6,22.376,22.376,0,0,0-2.58,1.628,16.813,16.813,0,0,0,2.6-.981s-1.324,1.3-1.2,1.443,1.7-.86,1.7-.86a3.182,3.182,0,0,0,1.039.131,2.433,2.433,0,0,0,1.349-.232Z",
    transform: "translate(-1025.944 -2821.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M1125.761,3098.04a.207.207,0,0,1-.18-.089c-.094-.108-.2-.228.469-.969-1.619.682-1.726.614-1.816.557a.223.223,0,0,1-.1-.182c0-.116-.005-.235,1.455-1.1-2.053.456-2.1.3-2.148.123s-.091-.327,1.9-1.132c-1.518.072-1.6-.091-1.645-.2a.251.251,0,0,1,.056-.288,15.56,15.56,0,0,1,4.1-1.247,6.176,6.176,0,0,1,2.772.393.211.211,0,0,1,.127.248l-.709,2.751a.212.212,0,0,1-.091.125,2.633,2.633,0,0,1-1.472.264,6.181,6.181,0,0,1-1-.111,4.632,4.632,0,0,1-1.711.855m1.176-1.88a.21.21,0,0,1,.147.361c-.3.3-.631.642-.859.906.315-.166.737-.415,1.1-.649.08-.051.151-.068.219-.007a4.6,4.6,0,0,0,.943.105,2.55,2.55,0,0,0,1.158-.166l.637-2.474a5.517,5.517,0,0,0-2.374-.308,23.128,23.128,0,0,0-3.428.912c.538.006,1.416-.043,2.194-.112a.21.21,0,0,1,.093.406c-.779.3-1.608.633-2.192.892.624-.118,1.488-.31,2.29-.507a.21.21,0,0,1,.154.387c-.432.245-.881.507-1.278.745.354-.146.739-.311,1.106-.473a.212.212,0,0,1,.085-.018",
    transform: "translate(-1023.725 -2818.943)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M1168.58,3051.8a5.565,5.565,0,0,0-3.213.244,18.99,18.99,0,0,0-3.794,2.765c-.181.393,3.386-1.217,3.386-1.217s-1.8,1.485-1.673,1.624a13.665,13.665,0,0,0,2.469-1.139s-1.281,1.189-.967,1.243,1.635-.935,1.635-.935-.189.107.651.049a10.131,10.131,0,0,0,1.38-.18Z",
    transform: "translate(-1058.485 -2780.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1162.646,3053.366a.278.278,0,0,1-.263-.187c-.019-.065-.051-.171.177-.479-1.386.7-1.486.6-1.583.5a.236.236,0,0,1-.064-.179c0-.064.012-.205.691-.833-2.1.892-2.24.752-2.336.655a.245.245,0,0,1-.043-.282,18.186,18.186,0,0,1,3.883-2.86,5.7,5.7,0,0,1,3.359-.267.21.21,0,0,1,.166.216l-.125,2.454a.211.211,0,0,1-.164.194,10.328,10.328,0,0,1-1.412.185,3,3,0,0,1-.664,0,4.5,4.5,0,0,1-1.622.885m.953-1.665a.21.21,0,0,1,.143.364c-.251.233-.522.508-.711.725a11.306,11.306,0,0,0,1.094-.726.263.263,0,0,1,.039-.027.209.209,0,0,1,.255.037,4.429,4.429,0,0,0,.485-.015,11.116,11.116,0,0,0,1.193-.145l.107-2.106a5.046,5.046,0,0,0-2.891.254,27.116,27.116,0,0,0-3.343,2.3c.634-.217,1.741-.678,2.747-1.132a.21.21,0,0,1,.22.354c-.413.34-.86.729-1.18,1.03.47-.219,1.135-.561,1.742-.893a.213.213,0,0,1,.1-.025",
    transform: "translate(-1056.328 -2778.683)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M996.655,3147.2a22.942,22.942,0,0,1-6.333-.876,41.988,41.988,0,0,1-7.21-.942c-4.257-.9-7.227-3.062-10.453-3s-20.848,3.945-20.848,3.945l2.391,7.828s16.024-2.839,18.282-3.67,9.2,2.81,16.117,3.7c5.2.67,12.232-.666,13.658-3.755s.251-4.653.251-4.653a28.809,28.809,0,0,1-5.855,1.416",
    transform: "translate(-867.343 -2863.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M989.22,3152.413a22.073,22.073,0,0,1-2.8-.173,54.545,54.545,0,0,1-9.484-2.391c-2.911-.928-5.425-1.73-6.533-1.323-2.249.828-17.663,3.563-18.318,3.679a.21.21,0,0,1-.238-.146l-2.391-7.829a.21.21,0,0,1,.156-.266c.72-.159,17.679-3.885,20.889-3.95a15,15,0,0,1,5.613,1.422,30.163,30.163,0,0,0,4.888,1.58,42.2,42.2,0,0,0,7.17.938.2.2,0,0,1,.054.008,22.883,22.883,0,0,0,6.258.868h0a28.755,28.755,0,0,0,5.8-1.4.211.211,0,0,1,.239.071c.051.068,1.235,1.7-.229,4.867-1.211,2.625-6.29,4.048-11.072,4.048M971.148,3148a24.066,24.066,0,0,1,5.912,1.45,54.192,54.192,0,0,0,9.41,2.375c5.241.675,12.1-.736,13.441-3.635,1.126-2.437.571-3.887.35-4.309a27.825,27.825,0,0,1-5.745,1.369,22.545,22.545,0,0,1-6.382-.875,43.081,43.081,0,0,1-7.222-.946,30.959,30.959,0,0,1-4.954-1.6,14.506,14.506,0,0,0-5.451-1.393c-2.974.06-18.533,3.442-20.585,3.891l2.27,7.433c1.786-.318,15.978-2.86,18.063-3.627a2.6,2.6,0,0,1,.894-.134",
    transform: "translate(-865.186 -2861.357)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M1327.5,3057.307h-.006c-.2,0-.211-.212-.214-.3a.207.207,0,0,1,.028-.113c0-.055.008-.118.013-.177a11.066,11.066,0,0,1,.125-1.213c.07-.324.124-.682.181-1.061a8.841,8.841,0,0,1,.555-2.312.21.21,0,1,1,.381.176,8.557,8.557,0,0,0-.521,2.2c-.058.386-.113.75-.187,1.088a11.313,11.313,0,0,0-.116,1.153c-.007.108-.014.2-.019.267-.008.1-.025.3-.221.3",
    transform: "translate(-1209.49 -2781.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1355.143,3165.106a1.772,1.772,0,0,1-1.572-.917.21.21,0,1,1,.37-.2,1.4,1.4,0,0,0,1.9.518.21.21,0,0,1,.2.37,1.894,1.894,0,0,1-.9.229",
    transform: "translate(-1233.427 -2883.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1087.787,2993.709l2.945,9.873Z",
    transform: "translate(-991.253 -2728.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M1088.573,3001.633a.21.21,0,0,1-.2-.15l-2.944-9.873a.21.21,0,0,1,.4-.12l2.945,9.873a.21.21,0,0,1-.141.261.213.213,0,0,1-.06.009",
    transform: "translate(-989.094 -2725.877)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M2982.187,3179.97l-1.076,9.368-8.714-.036s-.416-.546.323-.9c.527-.251.977-.211,1.486-.468s1.812-7.533,1.812-7.533Z",
    transform: "translate(-2708.509 -2897.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M2978.822,3187.272h0l-8.715-.036a.222.222,0,0,1-.176-.088.819.819,0,0,1-.143-.648.909.909,0,0,1,.547-.586,3.453,3.453,0,0,1,.786-.246,2.862,2.862,0,0,0,.678-.211c.309-.363,1.109-4.022,1.711-7.382a.222.222,0,0,1,.2-.183l6.169-.434a.223.223,0,0,1,.237.248l-1.076,9.368a.223.223,0,0,1-.221.2m-8.582-.481,8.383.035,1.022-8.9-5.728.4c-.091.5-.369,2-.686,3.506-.8,3.808-1.06,3.938-1.215,4.016a3.209,3.209,0,0,1-.8.257,3.042,3.042,0,0,0-.69.213c-.121.058-.273.155-.306.288a.317.317,0,0,0,.019.186",
    transform: "translate(-2706.219 -2895.479)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M2968.356,3251.9l9.422.043-.1-3.441c-1.546.144-2.964,1.925-4.526,1.51-.9-.233-1.683-1.183-2.545-1.146-.065.767-.156,1.3-.289,1.375-.552.307-1.04.266-1.61.563a.732.732,0,0,0-.35,1.1",
    transform: "translate(-2704.818 -2960.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M2877.609,3179.97l-1.076,9.368-8.714-.036s-.416-.546.323-.9c.527-.251.978-.211,1.486-.468s1.813-7.533,1.813-7.533Z",
    transform: "translate(-2613.211 -2897.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M2874.242,3187.272h0l-8.714-.036a.223.223,0,0,1-.176-.088.818.818,0,0,1-.143-.648.909.909,0,0,1,.547-.586,3.449,3.449,0,0,1,.786-.246,2.858,2.858,0,0,0,.678-.211c.308-.363,1.109-4.022,1.711-7.382a.222.222,0,0,1,.2-.183l6.168-.433a.223.223,0,0,1,.237.248l-1.076,9.368a.222.222,0,0,1-.221.2m-8.582-.481,8.383.035,1.023-8.9-5.728.4c-.091.5-.368,2-.686,3.506-.8,3.808-1.06,3.938-1.215,4.016a3.224,3.224,0,0,1-.8.257,3.025,3.025,0,0,0-.69.213c-.121.058-.274.155-.306.288a.316.316,0,0,0,.019.186",
    transform: "translate(-2610.92 -2895.479)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M2863.779,3251.9l9.422.043-.1-3.441c-1.546.144-2.964,1.925-4.526,1.51-.9-.233-1.683-1.183-2.545-1.146-.065.767-.155,1.3-.289,1.375-.552.307-1.04.266-1.609.563a.732.732,0,0,0-.35,1.1",
    transform: "translate(-2609.521 -2960.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M3089.222,2750.28a64.66,64.66,0,0,1-.255-6.876c.128-2.631.51-7.343.51-7.343l2.631-2.038,3.735-1.146,5.6,1.868,2.59,17.529-13.286.637Z",
    transform: "translate(-2814.817 -2490.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M3088.6,2750.963a.209.209,0,0,1-.182-.1l-1.528-2.631a.211.211,0,0,1-.028-.087,65.214,65.214,0,0,1-.256-6.9c.127-2.6.506-7.3.51-7.35a.208.208,0,0,1,.081-.149l2.631-2.038a.217.217,0,0,1,.067-.035l3.735-1.146a.206.206,0,0,1,.128,0l5.6,1.868a.209.209,0,0,1,.141.168l2.59,17.529a.21.21,0,0,1-.2.241l-13.285.636h-.01m-1.323-2.906,1.44,2.48,12.926-.619-2.537-17.172-5.416-1.806-3.634,1.115-2.528,1.957c-.054.673-.385,4.848-.5,7.244a63.834,63.834,0,0,0,.25,6.8",
    transform: "translate(-2812.663 -2488.194)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M3084.915,2664.059q-.171,0-.343-.016a3.584,3.584,0,0,1-2.323-1.117,2.924,2.924,0,0,1,.4-4.4,3.67,3.67,0,0,1,4.808.432,2.923,2.923,0,0,1-.4,4.4,3.548,3.548,0,0,1-2.142.7m-.127-5.818a3.134,3.134,0,0,0-1.891.617,2.5,2.5,0,0,0-.34,3.782,3.25,3.25,0,0,0,4.247.382,2.544,2.544,0,0,0,1.038-1.813h0a2.546,2.546,0,0,0-.7-1.969,3.163,3.163,0,0,0-2.052-.985c-.1-.009-.2-.014-.3-.014",
    transform: "translate(-2807.971 -2421.957)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M3144.862,2675.915a.806.806,0,0,0-.714-.861.756.756,0,0,0-.835.7.8.8,0,0,0,.714.861.757.757,0,0,0,.835-.7",
    transform: "translate(-2864.361 -2437.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M3141.952,2674.671c-.034,0-.069,0-.1-.005a1.017,1.017,0,0,1-.9-1.086.967.967,0,0,1,1.066-.893,1.019,1.019,0,0,1,.9,1.086h0a.968.968,0,0,1-.963.9m-.04-1.569a.54.54,0,0,0-.349.126.549.549,0,0,0-.2.384.594.594,0,0,0,.525.636.542.542,0,0,0,.408-.123.552.552,0,0,0,.2-.384.6.6,0,0,0-.526-.635c-.02,0-.039,0-.059,0m.794.655h0Z",
    transform: "translate(-2862.205 -2435.498)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M3124.165,2708.877c-.495.2-1.376.5-1.376.5,0,.19.434,2.21.434,2.21s.591.941,2.058.266,1.417-1.753,1.417-1.753l-1.043-2.406a7.814,7.814,0,0,1-1.491,1.185",
    transform: "translate(-2845.661 -2467.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M3122.145,2710.143a1.516,1.516,0,0,1-1.258-.607.206.206,0,0,1-.027-.068c-.1-.479-.438-2.056-.439-2.253a.211.211,0,0,1,.144-.2c.009,0,.881-.293,1.362-.492h0a7.292,7.292,0,0,0,1.423-1.141.21.21,0,0,1,.34.066l1.044,2.406a.219.219,0,0,1,.017.074c0,.05.038,1.227-1.54,1.953a2.554,2.554,0,0,1-1.066.261m-.884-.8c.1.132.622.691,1.774.161,1.182-.544,1.287-1.342,1.3-1.519l-.906-2.089a6.138,6.138,0,0,1-1.338,1.019c-.371.153-.945.352-1.226.448.059.346.233,1.2.4,1.98",
    transform: "translate(-2843.502 -2465.241)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M2890.809,2977.025l7.7,1.212,4.758-18.25a34.832,34.832,0,0,0,8.566-1.75c3.454-1.382,4.927-6.079,4.927-6.079L2897.421,2954s.369-.967-1.658,1.8-4.954,21.229-4.954,21.229",
    transform: "translate(-2634.267 -2690.172)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M3068.7,2630.75c.377.108-.338-.157-.545-.184-.693-.091-1.448-.147-2.151-.181-1.663-.082-5.874-.89-4.073-3.7.972-1.516,1.876.352,2.935.009.694-.225.884-1.14,1.509-1.315,1.741-.487,1.892,1.1,3.219,1.531.655.214,1.559-.164,1.819.762s-.395,3.569-1.174,4.116c-.418.293.169-1.5-.273-1.832-.811-.6-1.467.732-1.265.79",
    transform: "translate(-2789.802 -2392.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M3101.572,2752.034c3.286-1.026,6.339,4.453,6.827,6.443,1.1,4.492,1.387,8.47-.744,9.985-3.418,2.43-15.992,2.028-15.992,2.028l-1.669-3.158s10.55-1.565,11.808-2.823c2.042-2.041-3.516-11.448-.231-12.475",
    transform: "translate(-2815.776 -2507.693)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M3048.847,2772.138s-2.08,1.8-3.029,7.11-1.232,7.367-1.232,7.367l.411.693,3.773-1.258s-.359-3.312-.334-5.417.411-8.5.411-8.5",
    transform: "translate(-2774.397 -2526.128)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M3042.939,2930.687c.312-.395,4.379-1.788,4.379-1.788l1.5,2.928a34.465,34.465,0,0,1-4.167-.075c-.481-.177,2.243-.63,2.243-.63a21.08,21.08,0,0,1-3.407.445c-.208-.161,2.58-1.091,2.58-1.091s-3.443.6-3.13.21",
    transform: "translate(-2772.879 -2668.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M3044.587,2929.909a11.306,11.306,0,0,1-2.166-.118.266.266,0,0,1-.191-.2c-.885.1-.982.026-1.031-.012a.235.235,0,0,1-.088-.226c.014-.083.034-.2.8-.526-1.183.118-1.275-.034-1.326-.121a.262.262,0,0,1,.03-.3c.325-.411,3.508-1.524,4.476-1.855a.21.21,0,0,1,.255.1l1.5,2.928a.21.21,0,0,1-.181.306c-.3.008-1.187.03-2.078.03m-1.324-.443c.793.033,2.073.023,3.056,0l-1.266-2.468c-1.495.516-3.063,1.112-3.758,1.45a25.255,25.255,0,0,0,2.577-.337.21.21,0,0,1,.1.406c-.622.207-1.3.453-1.8.652.416-.052.957-.136,1.525-.233.277-.055.606-.115,1-.18a.21.21,0,0,1,.074.414c-.336.064-.639.119-.914.167-.214.043-.418.087-.6.128m-2.485-.938h0Z",
    transform: "translate(-2770.717 -2666.819)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M3000.361,2979.085l7.415,1.078,4.849-17.81s5.957-.114,9.331-1.681c4-1.859,3.99-6.442,3.99-6.442l-19.344,1.842s.369-.967-1.658,1.8-4.582,21.216-4.582,21.216",
    transform: "translate(-2734.098 -2692.061)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 44.988,
    height: 1.912,
    transform: "translate(247.998 263.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M2837.373,2968.7h-44.988a.21.21,0,0,1-.21-.21v-1.912a.21.21,0,0,1,.21-.21h44.988a.21.21,0,0,1,.21.21v1.912a.21.21,0,0,1-.21.21m-44.778-.42h44.568v-1.492H2792.6Z",
    transform: "translate(-2544.386 -2703.117)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M3149.038,2861.012a30.1,30.1,0,0,1-3.556-.206.21.21,0,1,1,.054-.417c.073.01,7.341.919,10.53-1.293,2.426-1.682,3.079-4.449,3.711-7.126.21-.89.409-1.73.67-2.539.274-.848.635-1.757.986-2.636.737-1.85,1.5-3.763,1.081-4.347-.035-.049-.14-.2-.528-.179-1.829.092-4.035,0-4.057,0a.21.21,0,1,1,.018-.42c.022,0,2.208.091,4.018,0a.96.96,0,0,1,.89.354c.551.77-.182,2.613-1.032,4.747-.347.873-.707,1.775-.976,2.61-.256.793-.452,1.626-.661,2.507-.65,2.753-1.323,5.6-3.881,7.375-1.842,1.278-4.878,1.57-7.267,1.57",
    transform: "translate(-2866.173 -2589.652)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M2779.814,3021.371l-.03,0a.21.21,0,0,1-.178-.238l3.237-22.452a3.54,3.54,0,0,1,1.017-2.391,2.672,2.672,0,0,1,2.306-.826.21.21,0,1,1-.09.411,2.258,2.258,0,0,0-1.924.718,3.146,3.146,0,0,0-.889,2.1.187.187,0,0,1,0,.033l-3.24,22.467a.21.21,0,0,1-.208.18",
    transform: "translate(-2532.931 -2729.607)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M3248.671,3019.2a.21.21,0,0,1-.208-.179l-3.338-22.468a.2.2,0,0,1,0-.034,3.106,3.106,0,0,0-.916-2.1,2.383,2.383,0,0,0-1.992-.72.21.21,0,0,1-.086-.411,2.8,2.8,0,0,1,2.365.824,3.484,3.484,0,0,1,1.049,2.393l3.335,22.452a.211.211,0,0,1-.177.239l-.031,0",
    transform: "translate(-2954.26 -2727.625)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M2847.923,2831.359H2831.76a.21.21,0,0,1-.2-.163l-2.714-11.639a.21.21,0,0,1,.2-.258l16.826-.061h0a.21.21,0,0,1,.207.174l2.051,11.7a.21.21,0,0,1-.207.246m-16-.42h15.746l-1.977-11.279-16.385.059Z",
    transform: "translate(-2577.794 -2569.049)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M2869.386,2952.8h-17.138a.21.21,0,0,1-.21-.21v-1.019a.21.21,0,0,1,.21-.21h17.138a.21.21,0,0,1,.21.21v1.019a.21.21,0,0,1-.21.21m-16.928-.42h16.718v-.6h-16.718Z",
    transform: "translate(-2598.937 -2689.45)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M2921.631,2879.349a1.244,1.244,0,1,1,1.531-1.211,1.4,1.4,0,0,1-1.531,1.211m0-2c-.613,0-1.111.354-1.111.79s.5.791,1.111.791,1.11-.354,1.11-.791-.5-.79-1.11-.79",
    transform: "translate(-2660.958 -2621.62)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M2924.483,3161.718a.21.21,0,0,1-.065-.41,14.793,14.793,0,0,0,4.465-2.534.21.21,0,1,1,.25.338,15.122,15.122,0,0,1-4.584,2.6.217.217,0,0,1-.065.01",
    transform: "translate(-2664.762 -2878.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M2927.419,3193.875a.91.91,0,0,1-.133-.009.21.21,0,0,1,.062-.416,5.618,5.618,0,0,0,3.032-1.524.21.21,0,1,1,.344.242,6.048,6.048,0,0,1-3.3,1.707",
    transform: "translate(-2667.344 -2908.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M3032.979,3164.519a2.191,2.191,0,0,1-.328-.023.21.21,0,0,1,.063-.416c1.21.18,3.22-.986,3.956-2.034a.21.21,0,1,1,.344.241,6.029,6.029,0,0,1-4.034,2.231",
    transform: "translate(-2763.359 -2881.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M3033.542,3198.245a.21.21,0,0,1-.065-.41,16.217,16.217,0,0,0,1.51-.609c.482-.213.979-.434,1.463-.591a.21.21,0,0,1,.13.4c-.464.151-.93.358-1.424.576a16.651,16.651,0,0,1-1.55.625.2.2,0,0,1-.065.01",
    transform: "translate(-2764.143 -2912.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M3235.67,2895.879a.211.211,0,0,1-.188-.116,2.07,2.07,0,0,0-1.173-1,2.017,2.017,0,0,0-1.583.079.21.21,0,1,1-.188-.376,2.434,2.434,0,0,1,1.91-.1,2.494,2.494,0,0,1,1.41,1.206.21.21,0,0,1-.094.282.208.208,0,0,1-.094.022",
    transform: "translate(-2945.564 -2637.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M3030.7,2991.08l-.031,0a.21.21,0,0,1-.177-.239c.209-1.382,1.2-4.333,2.921-4.632a.21.21,0,0,1,.072.414c-1.4.242-2.369,2.907-2.577,4.28a.21.21,0,0,1-.208.179",
    transform: "translate(-2761.551 -2721.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M4840.107,3177.164l-.359,9.73-8.714-.037s-.415-.545.324-.9c.527-.251.977-.211,1.486-.468s.166-7.936.166-7.936Z",
    transform: "translate(-4402.203 -2895.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M4837.458,3184.831h0l-8.714-.036a.221.221,0,0,1-.176-.088.818.818,0,0,1-.143-.648.91.91,0,0,1,.547-.586,3.458,3.458,0,0,1,.787-.245,2.918,2.918,0,0,0,.664-.2c.243-.464.23-4.272.075-7.742a.223.223,0,0,1,.21-.232l7.1-.393a.224.224,0,0,1,.169.063.227.227,0,0,1,.066.168l-.359,9.73a.223.223,0,0,1-.223.215m-8.582-.481,8.367.035.342-9.27-6.634.367c.022.561.081,2.108.1,3.659.046,4.043-.21,4.172-.4,4.265a3.211,3.211,0,0,1-.8.257,3.049,3.049,0,0,0-.691.213c-.121.058-.273.155-.306.289a.319.319,0,0,0,.02.186",
    transform: "translate(-4399.913 -2892.924)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M4826.994,3253.168l9.423.044-.1-3.442c-1.545.144-2.964,1.925-4.525,1.51-.9-.232-1.684-1.183-2.544-1.146-.065.768-.156,1.3-.29,1.375-.552.308-1.04.266-1.609.563a.732.732,0,0,0-.351,1.1",
    transform: "translate(-4398.513 -2961.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M4985.913,3171.185l.867,10.261-8.714-.037s-.416-.545.323-.9c.528-.251.978-.211,1.487-.468s-1.06-8.467-1.06-8.467Z",
    transform: "translate(-4536.186 -2889.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M4984.489,3179.38h0l-8.714-.036a.223.223,0,0,1-.176-.088.816.816,0,0,1-.143-.648.909.909,0,0,1,.547-.586,3.421,3.421,0,0,1,.786-.246,2.991,2.991,0,0,0,.651-.2c.171-.553-.434-4.585-1.134-8.248a.223.223,0,0,1,.207-.264l7.1-.393a.223.223,0,0,1,.234.2l.867,10.261a.223.223,0,0,1-.222.242m-8.582-.482,8.339.035-.828-9.8-6.628.367c.114.612.416,2.251.675,3.894.683,4.33.425,4.459.22,4.563a3.233,3.233,0,0,1-.8.257,3.025,3.025,0,0,0-.69.213c-.122.058-.273.155-.306.288a.307.307,0,0,0,.02.186",
    transform: "translate(-4533.896 -2887.473)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M4974.026,3253.573l9.422.043-.358-3.4c-1.545.144-2.708,1.885-4.27,1.471-.9-.232-2.059-1.187-2.92-1.151-.065.768-.155,1.3-.289,1.381-.552.307-.665.265-1.235.562a.732.732,0,0,0-.35,1.1",
    transform: "translate(-4532.497 -2961.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M4894.153,2538.105s3.064.652,3.977,2.542-4.042,17.014-4.042,17.014l-13.428-.2s.271-9.028,1.369-12.908a18.648,18.648,0,0,1,6.95-9.765Z",
    transform: "translate(-4447.531 -2309.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M4891.931,2555.714h0l-13.428-.2a.213.213,0,0,1-.149-.065.21.21,0,0,1-.058-.151c.011-.37.285-9.1,1.377-12.959a19.026,19.026,0,0,1,7.037-9.883.211.211,0,0,1,.228,0l5.144,3.291c.378.086,3.183.781,4.084,2.648.922,1.912-3.522,15.615-4.032,17.171a.21.21,0,0,1-.2.145m-13.211-.612,13.06.19c1.4-4.293,4.714-15.239,4-16.71-.856-1.774-3.8-2.422-3.831-2.428a.21.21,0,0,1-.069-.029l-5.058-3.236a18.625,18.625,0,0,0-6.752,9.569c-.985,3.481-1.3,11.256-1.354,12.644",
    transform: "translate(-4445.374 -2307.69)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M4986.891,2480.04a3.581,3.581,0,0,1-2.483-1.035,3.13,3.13,0,1,1,4.627.155,2.958,2.958,0,0,1-2.144.88m-.62-6.116a2.542,2.542,0,0,0-1.844.753,3.022,3.022,0,0,0,4.307,4.191h0a2.866,2.866,0,0,0-.273-4.027,3.165,3.165,0,0,0-2.19-.917",
    transform: "translate(-4541.066 -2253.996)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M5043.482,2515.93a.806.806,0,0,0-.011-1.118.757.757,0,0,0-1.09.017.806.806,0,0,0,.011,1.118.757.757,0,0,0,1.09-.017",
    transform: "translate(-4594.7 -2291.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M5040.779,2514.223a.961.961,0,0,1-.684-.285,1.017,1.017,0,0,1-.016-1.411.973.973,0,0,1,.7-.306h.012a.958.958,0,0,1,.684.285,1.018,1.018,0,0,1,.015,1.411.968.968,0,0,1-.693.305h-.014m.008-1.582h-.007a.552.552,0,0,0-.4.175.6.6,0,0,0,.007.824.561.561,0,0,0,.4.161.549.549,0,0,0,.394-.174h0a.6.6,0,0,0-.007-.825.544.544,0,0,0-.387-.162",
    transform: "translate(-4592.552 -2289.277)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M4991.667,2538.726c-.513-.153-1.382-.481-1.382-.481-.12.148-1.057,1.989-1.057,1.989s-.135,1.1,1.431,1.5a2.023,2.023,0,0,0,2.205-.468l.708-2.525a7.848,7.848,0,0,1-1.9-.019",
    transform: "translate(-4546.462 -2312.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M4989.305,2539.9a3.383,3.383,0,0,1-.841-.113c-1.725-.442-1.589-1.721-1.587-1.734a.206.206,0,0,1,.021-.07c.222-.437.957-1.872,1.081-2.025a.21.21,0,0,1,.238-.065c.008,0,.868.327,1.367.476h0a7.291,7.291,0,0,0,1.824.012.21.21,0,0,1,.222.266l-.707,2.525a.229.229,0,0,1-.034.068,1.964,1.964,0,0,1-1.585.659m-2.013-1.764c0,.167.047.929,1.275,1.244a1.88,1.88,0,0,0,1.963-.364l.614-2.192a6.161,6.161,0,0,1-1.681-.052c-.385-.115-.956-.323-1.233-.426-.173.305-.576,1.079-.937,1.789",
    transform: "translate(-4544.319 -2310.835)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M4999.01,2442.673c.225.321-.163-.335-.307-.486-.48-.507-1.03-1.027-1.555-1.5-1.24-1.112-4-4.393-.833-5.436,1.711-.563,1.235,1.456,2.274,1.857.68.263,1.4-.328,2-.07,1.658.72.776,2.045,1.533,3.218.374.579,1.314.856.932,1.738s-2.557,2.522-3.506,2.455c-.509-.036,1.08-1.062.942-1.594-.251-.977-1.6-.356-1.48-.184",
    transform: "translate(-4551.585 -2219.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M4969.483,2509.316c-.028-.015-.1.686-.2.846a1.724,1.724,0,0,1-1.255.877c-.631.158-2.057-1.306-2.808-1.494-.559-.14-2.466,1.741-2.151,2.37,1.456,2.91,7.25,3.07,8.107-.359.079-.313-.987-.042-1.116-.558-.279-1.118.643-1.058-.578-1.683",
    transform: "translate(-4522.595 -2286.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M4846.481,2582.239l3.676-2.108s4.378,6.6,6.811,6.271c2.737-.365,3.453-10.7,8.811-8.486,6.163,2.541-2.757,17.135-8.811,17.028s-10.487-12.7-10.487-12.7",
    transform: "translate(-4416.385 -2348.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M4892.621,2259.288l-3.352-13.73-.757-16.108,3.945-.433,2.378,13.568,2.919,9.352a6.539,6.539,0,0,0-.573,2.4l-.362,1.421Z",
    transform: "translate(-4454.687 -2031.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M4883.987,2152.5a27.641,27.641,0,0,0,1.2-4.334c-.034-.777-1.4,1.706-1.4,1.706s.5-4.483.034-4.568-.839,3.359-.839,3.359-.181-4.108-.715-3.932-.19,3.925-.19,3.925-.748-3.343-1.2-3.23.407,3.5.407,3.5-.919-2.273-1.318-2.115.583,3.233.583,3.233l.463,2.535Z",
    transform: "translate(-4446.815 -1954.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M4878.938,2150.635a.21.21,0,0,1-.207-.173l-.46-2.522c-1.038-3.249-.616-3.417-.457-3.479.1-.04.344-.136.809.609a3.94,3.94,0,0,1-.069-1.851.313.313,0,0,1,.449-.11,3.121,3.121,0,0,1,.681,1.377c-.024-1.716.2-2.031.441-2.112a.316.316,0,0,1,.283.043,4.223,4.223,0,0,1,.567,2.156,3.344,3.344,0,0,1,.556-1.57.314.314,0,0,1,.251-.063c.259.047.463.271.33,2.535-.027.455-.063.911-.1,1.293.733-1.193.958-1.141,1.075-1.113.08.019.216.088.228.344a25.849,25.849,0,0,1-1.211,4.412.209.209,0,0,1-.192.141l-2.972.082Zm2.972-.292h0Zm-3.908-5.419a13.477,13.477,0,0,0,.674,2.9c0,.008,0,.017.007.026l.43,2.358,2.646-.073a32.3,32.3,0,0,0,1.124-3.885,13.251,13.251,0,0,0-.986,1.565.21.21,0,0,1-.394-.124,23.313,23.313,0,0,0,.189-4.207,14.8,14.8,0,0,0-.577,3.044.21.21,0,0,1-.209.187h-.007a.21.21,0,0,1-.2-.2,15.626,15.626,0,0,0-.47-3.666,13.537,13.537,0,0,0-.016,3.631.21.21,0,0,1-.414.065,14.5,14.5,0,0,0-.915-2.958,14.991,14.991,0,0,0,.533,3.133.21.21,0,0,1-.4.13,8.105,8.105,0,0,0-1.014-1.927",
    transform: "translate(-4444.737 -1952.238)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M4741.008,2536.605l1.3-.12s2.373,4.516,6.6,4.055c4.1-.447,5.089-4.907,5.089-4.907l1.338-.115s-1.482,5.955-6.159,6.3c-5.735.427-8.171-5.216-8.171-5.216",
    transform: "translate(-4320.272 -2310.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M4746.415,2539.9a8,8,0,0,1-5.78-2.534,10.372,10.372,0,0,1-1.977-2.832.21.21,0,0,1,.173-.292l1.3-.12a.209.209,0,0,1,.2.112c.023.044,2.358,4.385,6.394,3.944,3.9-.425,4.9-4.7,4.907-4.744a.208.208,0,0,1,.187-.164l1.338-.115a.212.212,0,0,1,.178.073.209.209,0,0,1,.043.187c-.015.061-1.573,6.106-6.347,6.462-.211.016-.42.024-.623.024m-7.241-5.268c.568,1.094,3.024,5.182,7.833,4.825,3.893-.291,5.521-4.684,5.888-5.858l-.886.076c-.225.8-1.469,4.509-5.232,4.92a5.8,5.8,0,0,1-.62.034c-3.551,0-5.713-3.38-6.121-4.076Z",
    transform: "translate(-4318.115 -2308.349)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M4819.964,2566.06s-2.953-2.331-2.778-3.374,3.147-3.159,4.1-2.914a1.494,1.494,0,0,1,.987,1.378l1.38-1.4a4.242,4.242,0,0,1,.368,1.962,7.175,7.175,0,0,1-.508,2.325Z",
    transform: "translate(-4389.684 -2332.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M4817.816,2564.116a.212.212,0,0,1-.13-.045c-.312-.247-3.044-2.441-2.854-3.574.115-.687,1.171-1.649,2.167-2.3.447-.291,1.556-.95,2.192-.786a1.543,1.543,0,0,1,1.076,1.142l1.091-1.1a.212.212,0,0,1,.125-.062.243.243,0,0,1,.189.063,4.735,4.735,0,0,1,.411,2.108,7.318,7.318,0,0,1-.523,2.406.212.212,0,0,1-.09.1l-3.55,2.02a.209.209,0,0,1-.1.027m1.146-6.309a4.005,4.005,0,0,0-1.734.746c-1.052.685-1.9,1.55-1.982,2.014-.108.648,1.487,2.2,2.59,3.086l3.361-1.913a6.842,6.842,0,0,0,.467-2.179,6.7,6.7,0,0,0-.211-1.609l-1.177,1.191a.21.21,0,0,1-.36-.141c0-.04-.045-.979-.83-1.182a.516.516,0,0,0-.124-.014",
    transform: "translate(-4387.537 -2330.436)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M4852.595,2791.856s-2.446,15.679-2.806,19.706.036,18.739.036,18.739l7.675.085,1.148-18.22,2.967,18.115,8.6-.052-4.1-38.229Z",
    transform: "translate(-4419.263 -2544.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M4993.847,3198.517h0l-7.815-.056a.21.21,0,0,1-.209-.211.215.215,0,0,1,.212-.209l7.815.056a.21.21,0,0,1,0,.42",
    transform: "translate(-4543.36 -2914.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M4859.7,3195.3h-7.367a.21.21,0,0,1,0-.42h7.367a.21.21,0,1,1,0,.42",
    transform: "translate(-4421.524 -2911.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M4920.127,2892.591a.21.21,0,0,1-.208-.189l-1.01-9.837-1.581-2.663a.21.21,0,1,1,.361-.214l1.605,2.7a.212.212,0,0,1,.028.085l1.014,9.884a.21.21,0,0,1-.187.23h-.022",
    transform: "translate(-4480.918 -2624.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M4563.719,2159.338l-14.792,35.514,31.322-2.087,3.2-8.283Z",
    transform: "translate(-4145.238 -1967.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M4546.769,2192.9a.21.21,0,0,1-.194-.291l14.792-35.514a.21.21,0,0,1,.359-.049l19.731,25.143a.211.211,0,0,1,.031.206l-3.2,8.283a.21.21,0,0,1-.182.134l-31.323,2.087h-.014m14.848-35.312-14.523,34.869,30.85-2.056,3.109-8.047Z",
    transform: "translate(-4143.079 -1965.553)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M4905.595,2446.093l3,1.639-2.771,7.112-3.366-.6Z",
    transform: "translate(-4467.396 -2229.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M4903.668,2452.9a.217.217,0,0,1-.037,0l-3.367-.6a.21.21,0,0,1-.159-.282l3.134-8.147a.21.21,0,0,1,.3-.109l3,1.639a.21.21,0,0,1,.095.261l-2.772,7.113a.211.211,0,0,1-.2.134m-3.079-.977,2.946.529,2.642-6.779-2.631-1.436Z",
    transform: "translate(-4465.239 -2226.858)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M4552.357,2085.6a.209.209,0,0,1-.155-.068l-11.068-11.974a.21.21,0,1,1,.309-.285l11.068,11.973a.21.21,0,0,1-.012.3.207.207,0,0,1-.142.056",
    transform: "translate(-4138.086 -1889.221)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M4483.164,2199.7a.206.206,0,0,1-.116-.036l-12.326-8.236a.21.21,0,0,1,.234-.35l12.325,8.236a.21.21,0,0,1-.117.385",
    transform: "translate(-4073.887 -1996.604)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M4438.356,2310.6a.21.21,0,0,1-.083-.018l-12.792-5.552a.21.21,0,0,1,.167-.385l12.791,5.552a.21.21,0,0,1-.083.4",
    transform: "translate(-4032.631 -2100.105)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M4398.878,2451.1a.211.211,0,0,1-.046,0l-13.008-2.909a.21.21,0,0,1,.092-.41l13.008,2.909a.21.21,0,0,1-.045.415",
    transform: "translate(-3996.459 -2230.55)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M4582.289,2222.571a.215.215,0,0,1-.081-.016.211.211,0,0,1-.113-.275l13.088-31.427a.21.21,0,1,1,.387.162l-13.087,31.427a.21.21,0,0,1-.194.13",
    transform: "translate(-4175.447 -1996.31)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M4749.486,2238.665a.209.209,0,0,1-.166-.082l-1.807-2.338a.21.21,0,1,1,.333-.257l1.807,2.339a.21.21,0,0,1-.166.339",
    transform: "translate(-4326.16 -2037.484)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M4797.8,2295.451a.211.211,0,0,1-.165-.079l-9.7-12.111a.21.21,0,1,1,.328-.263l9.7,12.111a.211.211,0,0,1-.164.342",
    transform: "translate(-4362.994 -2080.326)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M4384.31,2932.971h-.058a.257.257,0,0,1-.252-.272,45.556,45.556,0,0,1,1.477-8.2c1.155-4.26,3.447-10.329,7.809-15.043s10.152-7.456,14.243-8.926a43.98,43.98,0,0,1,7.912-2.081.257.257,0,0,1,.292.261c0,.095-.328,9.646-7.924,21.98a25.739,25.739,0,0,1-14.679,10.847,32.559,32.559,0,0,1-8.819,1.434m30.892-33.964a45.179,45.179,0,0,0-7.512,2.011c-4.032,1.45-9.74,4.152-14.027,8.787s-6.55,10.625-7.69,14.829a46.6,46.6,0,0,0-1.439,7.821,32.551,32.551,0,0,0,8.462-1.414,25.227,25.227,0,0,0,14.375-10.62c6.762-10.978,7.706-19.691,7.831-21.414",
    transform: "translate(-3994.947 -2641.229)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M4390.115,2940.958a.256.256,0,0,1-.188-.43l30.2-32.892a.257.257,0,0,1,.378.347l-30.2,32.892a.255.255,0,0,1-.189.083",
    transform: "translate(-4000.286 -2649.526)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M4514.014,3156.117a.257.257,0,0,1,0-.513l10.969-.022h0a.257.257,0,0,1,0,.513l-10.969.022Z",
    transform: "translate(-4113.189 -2875.544)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M4557.834,3114.466h-.024l-9.366-.864a.256.256,0,0,1-.232-.279.259.259,0,0,1,.279-.232l9.366.864a.256.256,0,0,1-.023.512",
    transform: "translate(-4144.585 -2836.822)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M4593.623,2952.886a.257.257,0,0,1-.256-.24l-.636-9.408a.257.257,0,0,1,.513-.035l.635,9.408a.257.257,0,0,1-.239.273h-.017",
    transform: "translate(-4185.153 -2681.795)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M4442.338,3093.042a.257.257,0,0,1-.251-.206l-2.018-9.939a.257.257,0,0,1,.5-.1l2.018,9.939a.258.258,0,0,1-.2.3.27.27,0,0,1-.052.005",
    transform: "translate(-4046.036 -2809.029)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M653.592,2216.777h0l-87.159-.14a.3.3,0,0,1-.3-.3l.141-87.159a.3.3,0,0,1,.3-.3h0l26.191.042a17.409,17.409,0,0,1,17.387-16.668h.029a17.409,17.409,0,0,1,17.362,16.723l26.191.042a.3.3,0,0,1,.3.3l-.043,26.39a17.41,17.41,0,0,1-.056,34.805l-.042,25.964a.3.3,0,0,1-.3.3m-86.861-.735,86.564.139.042-25.958a.3.3,0,0,1,.295-.3,16.814,16.814,0,0,0,.054-33.626.3.3,0,0,1-.294-.3l.043-26.384-26.182-.042a.3.3,0,0,1-.3-.291,16.717,16.717,0,0,0-16.776-16.432h-.028a16.715,16.715,0,0,0-16.8,16.378.3.3,0,0,1-.3.29h0l-26.182-.042Z",
    transform: "translate(-515.894 -1924.807)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M2617.24,2216.8h0l-87.164-.137a.3.3,0,0,1-.3-.3l.041-26.193a.3.3,0,0,1,.3-.3h0a.3.3,0,0,1,.3.3l-.04,25.9,86.568.136.04-25.96a.3.3,0,0,1,.295-.3,16.81,16.81,0,0,0,.055-33.618.3.3,0,0,1-.294-.3l.04-26.385-26.177-.048a.3.3,0,0,1-.3-.291,16.723,16.723,0,0,0-16.781-16.427h-.031a16.723,16.723,0,0,0-16.8,16.379.3.3,0,0,1-.3.29h0l-26.177-.048-.04,26.176a.3.3,0,0,1-.3.3h0a.3.3,0,0,1-.3-.3l.04-26.475a.3.3,0,0,1,.3-.3h0l26.186.048a17.415,17.415,0,0,1,17.385-16.669h.031A17.415,17.415,0,0,1,2591.191,2129l26.187.048a.3.3,0,0,1,.3.3l-.039,26.392a17.406,17.406,0,0,1-.058,34.8l-.04,25.965a.3.3,0,0,1-.3.3",
    transform: "translate(-2305.277 -1924.834)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M4210.641,1648.636a.317.317,0,0,1-.312-.369l2.364-14.186a.317.317,0,0,1,.515-.193l11.1,9.14a.318.318,0,0,1-.091.542l-13.467,5.045a.315.315,0,0,1-.111.02m2.587-13.909-2.184,13.1,12.438-4.66Z",
    transform: "translate(-3836.684 -1488.825)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M3270.532,2539.872a.319.319,0,0,1-.15-.038l-9.944-5.329a.318.318,0,0,1-.017-.549l9.587-5.948a.317.317,0,0,1,.484.259l.357,11.277a.317.317,0,0,1-.317.327m-9.31-5.667,8.975,4.81-.322-10.178Z",
    transform: "translate(-2970.941 -2303.62)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M553.172,918.449A.317.317,0,0,1,553,918.4l-11.936-8.021a.317.317,0,0,1,.037-.548l12.915-6.327a.317.317,0,0,1,.456.307l-.978,14.348a.318.318,0,0,1-.316.3m-11.3-8.3,11.024,7.408.9-13.251Z",
    transform: "translate(-492.915 -823.29)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M1629.457,4.9a.317.317,0,0,1-.223-.543L1633.542.1a.317.317,0,1,1,.446.451l-4.308,4.26a.316.316,0,0,1-.223.092",
    transform: "translate(-1484.563 -0.004)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M1389.729,110.135a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-1266.11 -84.183)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M1520.364,57.005a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-1385.152 -35.769)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M3087.337,2303.3a.317.317,0,0,1-.223-.542l4.308-4.26a.317.317,0,1,1,.446.451l-4.308,4.26a.317.317,0,0,1-.223.091",
    transform: "translate(-2813.065 -2094.44)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M2847.609,2408.541a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-2594.612 -2178.619)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M2978.243,2355.411a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-2713.653 -2130.205)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M1285.569,2417.2a.317.317,0,0,1-.223-.543l4.308-4.26a.317.317,0,0,1,.446.451l-4.308,4.26a.317.317,0,0,1-.223.092",
    transform: "translate(-1171.193 -2198.232)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M1045.842,2522.441a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.317.317,0,0,1-.223.092",
    transform: "translate(-952.741 -2282.412)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M1176.478,2469.313a.317.317,0,0,1-.223-.542l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.317.317,0,0,1-.223.092",
    transform: "translate(-1071.783 -2233.999)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M5370.251,2598.162a.317.317,0,0,1-.223-.543l4.308-4.26a.317.317,0,0,1,.446.451l-4.308,4.26a.317.317,0,0,1-.223.092",
    transform: "translate(-4893.385 -2363.132)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M5130.522,2703.4a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.317.317,0,0,1-.224.092",
    transform: "translate(-4674.931 -2447.311)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M5261.158,2650.271a.317.317,0,0,1-.224-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.314.314,0,0,1-.223.092",
    transform: "translate(-4793.972 -2398.898)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M3304.8,735.989a.317.317,0,0,1-.223-.543l4.308-4.26a.317.317,0,1,1,.446.451l-4.308,4.26a.316.316,0,0,1-.223.092",
    transform: "translate(-3011.228 -666.215)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M3065.069,841.225a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451l-17.3,17.119a.315.315,0,0,1-.223.092",
    transform: "translate(-2792.774 -750.394)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M3195.7,788.1a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,1,1,.446.451L3195.927,788a.315.315,0,0,1-.223.092",
    transform: "translate(-2911.816 -701.98)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M4483.7,2728.2a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-4085.506 -2469.915)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M214.7,1982.15a.317.317,0,0,1-.223-.543l4.308-4.26a.317.317,0,1,1,.446.451l-4.308,4.26a.317.317,0,0,1-.223.092",
    transform: "translate(-195.357 -1801.787)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M.318,2055.511a.317.317,0,0,1-.223-.542l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(0 -1856.92)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M279.965,1788.057a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.317.317,0,0,1-.223.092",
    transform: "translate(-254.83 -1613.201)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M111.094,2023.606a.317.317,0,0,1-.223-.543l17.3-17.119a.317.317,0,0,1,.446.451l-17.3,17.119a.316.316,0,0,1-.223.092",
    transform: "translate(-100.946 -1827.845)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M5222.186,3053.483a4.112,4.112,0,1,1,4.113-4.112,4.117,4.117,0,0,1-4.113,4.112m0-7.712a3.6,3.6,0,1,0,3.6,3.6,3.6,3.6,0,0,0-3.6-3.6",
    transform: "translate(-4755.001 -2775.011)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M2317.728,1853.721a5.621,5.621,0,1,1,5.621-5.621,5.628,5.628,0,0,1-5.621,5.621m0-10.73a5.108,5.108,0,1,0,5.108,5.108,5.114,5.114,0,0,0-5.108-5.108",
    transform: "translate(-2106.921 -1678.97)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M3081.414,387.725a5.621,5.621,0,1,1,5.622-5.622,5.628,5.628,0,0,1-5.622,5.622m0-10.73a5.108,5.108,0,1,0,5.108,5.108,5.114,5.114,0,0,0-5.108-5.108",
    transform: "translate(-2802.835 -343.072)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M1628.595,1719.185a2.765,2.765,0,1,1,2.765-2.765,2.768,2.768,0,0,1-2.765,2.765m0-5.016a2.252,2.252,0,1,0,2.252,2.251,2.254,2.254,0,0,0-2.252-2.251",
    transform: "translate(-1481.547 -1561.579)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M2374.65,70.33a2.765,2.765,0,1,1,2.765-2.765,2.768,2.768,0,0,1-2.765,2.765m0-5.016a2.252,2.252,0,1,0,2.251,2.252,2.254,2.254,0,0,0-2.251-2.252",
    transform: "translate(-2161.395 -59.05)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M2572.015,2754.786a5.621,5.621,0,1,1,5.621-5.622,5.628,5.628,0,0,1-5.621,5.622m0-10.73a5.108,5.108,0,1,0,5.108,5.108,5.114,5.114,0,0,0-5.108-5.108",
    transform: "translate(-2338.641 -2500.071)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M3439.591,2769.986a2.765,2.765,0,1,1,2.765-2.765,2.768,2.768,0,0,1-2.765,2.765m0-5.016a2.251,2.251,0,1,0,2.251,2.251,2.254,2.254,0,0,0-2.251-2.251",
    transform: "translate(-3131.829 -2519.128)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M766.33,2518.706a2.765,2.765,0,1,1,2.765-2.765,2.768,2.768,0,0,1-2.765,2.765m0-5.017a2.252,2.252,0,1,0,2.252,2.252,2.254,2.254,0,0,0-2.252-2.252",
    transform: "translate(-695.803 -2290.148)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 9.109,
    height: 5.69,
    transform: "translate(74.1 265.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M841.943,3000.639h-9.109a.21.21,0,0,1-.21-.21v-5.69a.21.21,0,0,1,.21-.21h9.109a.21.21,0,0,1,.21.21v5.69a.21.21,0,0,1-.21.21m-8.9-.42h8.689v-5.269h-8.689Z",
    transform: "translate(-758.734 -2728.783)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M839.546,2999.74l4.554-2.845h-9.109Z",
    transform: "translate(-760.891 -2730.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M837.388,2997.794a.21.21,0,0,1-.111-.032l-4.554-2.845a.21.21,0,0,1,.111-.388h9.109a.21.21,0,0,1,.111.388l-4.554,2.845a.211.211,0,0,1-.111.032m-3.821-2.845,3.821,2.387,3.821-2.387Z",
    transform: "translate(-758.733 -2728.783)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M2897.225,1802.754a2.887,2.887,0,0,0-2.674-3.046,2.824,2.824,0,0,0-3.148,2.5,2.887,2.887,0,0,0,2.675,3.046,2.823,2.823,0,0,0,3.147-2.5",
    transform: "translate(-2634.801 -1639.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M2892.389,1803.466q-.156,0-.315-.015a3.085,3.085,0,0,1-2.849-3.255,2.864,2.864,0,0,1,1.033-1.965,3.135,3.135,0,0,1,2.325-.706,3.084,3.084,0,0,1,2.848,3.255,2.864,2.864,0,0,1-1.033,1.965,3.114,3.114,0,0,1-2.01.721m-.12-5.569a2.731,2.731,0,0,0-1.763.631,2.482,2.482,0,0,0-.9,1.7,2.7,2.7,0,0,0,2.5,2.837,2.753,2.753,0,0,0,2.04-.618,2.481,2.481,0,0,0,.9-1.7,2.7,2.7,0,0,0-2.5-2.837c-.093-.009-.186-.013-.278-.013",
    transform: "translate(-2632.815 -1637.992)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M2931.386,1846.3c-.449.2-.93.423-.93.423a5.622,5.622,0,0,0,.538,1.057,6.73,6.73,0,0,0,1.461.057c1.468-.21,1.73-.73,1.73-.73l-1.444-1.943a7.214,7.214,0,0,1-1.355,1.135",
    transform: "translate(-2670.396 -1681.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M2930.07,1846.076a8.582,8.582,0,0,1-1.085-.083.192.192,0,0,1-.136-.09,4.042,4.042,0,0,1-.566-1.158.193.193,0,0,1,.11-.174c.005,0,.49-.232.937-.426a6.725,6.725,0,0,0,1.292-1.092.19.19,0,0,1,.152-.059.193.193,0,0,1,.142.077l1.444,1.943a.194.194,0,0,1,.018.2c-.031.063-.352.617-1.875.835a3.157,3.157,0,0,1-.431.026m-.941-.453a6.083,6.083,0,0,0,1.317.046,2.783,2.783,0,0,0,1.511-.547l-1.219-1.64a5.892,5.892,0,0,1-1.257,1.016h0c-.292.126-.6.268-.777.351.076.17.252.49.424.774m.276-1.3h0Z",
    transform: "translate(-2668.415 -1679.439)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M2745.912,2238.026l2.613,9.061-8.057,3.321s-.594-.344-.047-.953c.39-.435.821-.571,1.192-1s-1.227-7.65-1.227-7.65Z",
    transform: "translate(-2497.014 -2039.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M2738.177,2248.341a.227.227,0,0,1-.112-.03.819.819,0,0,1-.381-.543.91.91,0,0,1,.28-.751,3.428,3.428,0,0,1,.631-.529,2.873,2.873,0,0,0,.545-.456c.145-.454-.524-4.139-1.262-7.472a.222.222,0,0,1,.118-.247l5.526-2.775a.223.223,0,0,1,.314.138l2.613,9.061a.223.223,0,0,1-.129.268l-8.057,3.321a.224.224,0,0,1-.085.017m.173-9.708c.107.493.429,1.987.717,3.5.726,3.823.537,4.042.424,4.174a3.188,3.188,0,0,1-.64.545,3.036,3.036,0,0,0-.555.462.529.529,0,0,0-.172.381.31.31,0,0,0,.089.167l7.751-3.195-2.483-8.611Z",
    transform: "translate(-2494.724 -2037.126)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M2736.951,2311.558l8.713-3.587-1.42-3.137c-1.371.728-2,2.917-3.6,3.136-.917.13-2.009-.444-2.79-.078.236.734.355,1.256.263,1.381-.391.5-.858.646-1.269,1.139a.732.732,0,0,0,.1,1.146",
    transform: "translate(-2493.763 -2100.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M2860.158,2238.026l2.613,9.061-8.057,3.321s-.593-.344-.047-.953c.39-.435.821-.571,1.192-1s-1.227-7.65-1.227-7.65Z",
    transform: "translate(-2601.122 -2039.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M2852.423,2248.341a.226.226,0,0,1-.112-.03.816.816,0,0,1-.381-.543.907.907,0,0,1,.279-.751,3.445,3.445,0,0,1,.631-.529,2.867,2.867,0,0,0,.545-.456c.145-.454-.525-4.139-1.263-7.472a.223.223,0,0,1,.118-.247l5.526-2.775a.223.223,0,0,1,.314.138l2.613,9.061a.224.224,0,0,1-.129.268l-8.057,3.321a.224.224,0,0,1-.085.017m.173-9.708c.108.493.429,1.987.717,3.5.726,3.823.537,4.042.425,4.174a3.2,3.2,0,0,1-.64.545,3.053,3.053,0,0,0-.555.462.533.533,0,0,0-.172.381.313.313,0,0,0,.089.167l7.751-3.195-2.483-8.611Z",
    transform: "translate(-2598.831 -2037.126)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M2851.2,2311.558l8.713-3.587-1.42-3.137c-1.371.728-1.995,2.917-3.6,3.136-.917.13-2.009-.444-2.79-.078.235.734.355,1.256.263,1.381-.391.5-.858.646-1.269,1.139a.732.732,0,0,0,.1,1.146",
    transform: "translate(-2597.87 -2100.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M2897.75,1737.434c-.089.01,3.658-.03,4.231-.03,4.208,0,6.912,6.029,3.174,8.521-3.871,2.581-7.219-1.29-10.578-2.409-3.222-1.074-4.6,1.59-7.228,2.116-1.981.4-4.584-2.562-6.238-4.437-.389-.442-.726-.823-.99-1.087-1.005-1.005-2.7.4-3.7-.353a3.29,3.29,0,0,1-1.234-3.35c1.311-6.559,7.547-3.251,11.165-2.527,2.154.431,4.206-1.973,5.994.411a8.731,8.731,0,0,0,3.409,2.527c.647.259,2.69.535,2,.617",
    transform: "translate(-2619.964 -1578.664)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M2943.433,1812.479a.888.888,0,0,0-.8-.94.845.845,0,0,0-.941.765.887.887,0,0,0,.8.94.846.846,0,0,0,.942-.765",
    transform: "translate(-2680.629 -1650.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M2940.6,1811.459a1.091,1.091,0,0,1-1.088-1.153,1.014,1.014,0,0,1,.364-.7,1.054,1.054,0,0,1,.789-.238,1.083,1.083,0,0,1,.978,1.147h0a1.013,1.013,0,0,1-.364.7,1.05,1.05,0,0,1-.678.244m-.046-1.714a.667.667,0,0,0-.431.155.63.63,0,0,0-.227.437.693.693,0,0,0,.63.733.672.672,0,0,0,.5-.151.629.629,0,0,0,.227-.437.7.7,0,0,0-.632-.733.709.709,0,0,0-.072,0m.9.752h0Z",
    transform: "translate(-2678.647 -1648.79)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M2870.622,1876.595a6.359,6.359,0,0,0-4.364,2.669,10.45,10.45,0,0,0-1.79,4.145l2.167,6,.973-.031Z",
    transform: "translate(-2610.264 -1710.059)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M2734.134,2053.918h-1.918l2.62,16.334-7.854-.678s-2.255-16.479-.794-19.584,19.274-2.375,19.274-2.375Z",
    transform: "translate(-2483.805 -1865.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M2732.851,2068.472h-.017l-7.854-.678a.193.193,0,0,1-.175-.166c-.092-.676-2.246-16.571-.777-19.693.639-1.358,4.122-2.187,10.351-2.463,4.591-.2,9.061-.024,9.105-.022a.193.193,0,0,1,.086.361l-11.327,6.3a.194.194,0,0,1-.094.025h-1.692l2.584,16.111a.193.193,0,0,1-.19.223m-7.684-1.05,7.454.644-2.581-16.09a.193.193,0,0,1,.19-.224h1.868l10.678-5.942c-5.345-.171-17.3-.056-18.4,2.289-1.346,2.862.567,17.651.79,19.323",
    transform: "translate(-2481.822 -1863.861)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M2824.507,2049.606s14.293,2.16,14.843-2.466c.914-7.673-19.525-3.119-21.238.5-1.187,2.512,3.031,18.319,3.031,18.319l8.065.055Z",
    transform: "translate(-2567.831 -1861.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M2827.29,2064.224h0l-8.065-.056a.193.193,0,0,1-.185-.143c-.173-.648-4.223-15.9-3.019-18.451.625-1.322,3.63-2.826,7.655-3.833,4.244-1.061,8.3-1.256,10.846-.524,2.26.65,3.333,2.019,3.1,3.959a2.455,2.455,0,0,1-1.023,1.689c-3.049,2.323-11.966,1.233-13.744.988l4.62,16.124a.193.193,0,0,1-.185.246m-7.916-.44,7.659.053-4.631-16.162a.193.193,0,0,1,.041-.18.19.19,0,0,1,.174-.063c.105.016,10.558,1.561,13.75-.871a2.053,2.053,0,0,0,.873-1.427c.209-1.752-.742-2.944-2.825-3.543-2.485-.715-6.465-.518-10.646.528-3.857.964-6.832,2.421-7.4,3.623-1.085,2.3,2.59,16.463,3.006,18.044",
    transform: "translate(-2565.911 -1859.674)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M2897.617,1869.609l-4.4-2.422a3.926,3.926,0,0,1-1.515.8,3.525,3.525,0,0,1-1.651-.139,19.913,19.913,0,0,0-3.275,3.237c-.9,1.126-1.589,1.965-.952,4.96s1.333,5.5,1.333,5.5l9.943-1.092Z",
    transform: "translate(-2629.502 -1701.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M2885.178,1879.757a.194.194,0,0,1-.186-.141c-.007-.025-.705-2.547-1.336-5.513-.651-3.059.063-3.956.966-5.091l.023-.029a20.3,20.3,0,0,1,3.311-3.271.193.193,0,0,1,.179-.027,3.35,3.35,0,0,0,1.547.132,3.737,3.737,0,0,0,1.427-.756.192.192,0,0,1,.22-.024l4.4,2.422a.193.193,0,0,1,.1.178l-.514,10.847a.193.193,0,0,1-.172.183l-9.943,1.091h-.021m2.931-13.677a20.125,20.125,0,0,0-3.162,3.143l-.023.029c-.873,1.1-1.5,1.891-.891,4.771.539,2.531,1.126,4.736,1.288,5.332l9.615-1.056.5-10.562-4.178-2.3a3.943,3.943,0,0,1-1.5.757,3.613,3.613,0,0,1-1.653-.113",
    transform: "translate(-2627.52 -1699.503)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M2897.617,1869.609l-4.4-2.422a3.926,3.926,0,0,1-1.515.8,3.525,3.525,0,0,1-1.651-.139,19.913,19.913,0,0,0-3.275,3.237c-.9,1.126-1.589,1.965-.952,4.96s1.333,5.5,1.333,5.5l9.943-1.092Z",
    transform: "translate(-2629.502 -1701.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M2885.178,1879.757a.194.194,0,0,1-.186-.141c-.007-.025-.705-2.547-1.336-5.513-.651-3.059.063-3.956.966-5.091l.023-.029a20.3,20.3,0,0,1,3.311-3.271.193.193,0,0,1,.179-.027,3.35,3.35,0,0,0,1.547.132,3.737,3.737,0,0,0,1.427-.756.192.192,0,0,1,.22-.024l4.4,2.422a.193.193,0,0,1,.1.178l-.514,10.847a.193.193,0,0,1-.172.183l-9.943,1.091h-.021m2.931-13.677a20.125,20.125,0,0,0-3.162,3.143l-.023.029c-.873,1.1-1.5,1.891-.891,4.771.539,2.531,1.126,4.736,1.288,5.332l9.615-1.056.5-10.562-4.178-2.3a3.943,3.943,0,0,1-1.5.757,3.613,3.613,0,0,1-1.653-.113",
    transform: "translate(-2627.52 -1699.503)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M2895.72,1896.528c1.781-2.167-4.3-7.764.787-9.491,3.054-1.036,7.919,9.192,5.3,13.085-2.708,4.022-14.857.923-14.857.923l-.8-2.4s7.79.054,9.572-2.113",
    transform: "translate(-2630.02 -1719.508)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M2730.587,1953.489l-3.419-9.715-13.071.1,3.873,9.735Z",
    transform: "translate(-2473.238 -1771.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M2715.989,1951.822a.193.193,0,0,1-.179-.122l-3.873-9.734a.193.193,0,0,1,.178-.264l13.071-.1a.2.2,0,0,1,.184.129l3.419,9.715a.193.193,0,0,1-.18.257l-12.617.121Zm-3.59-9.737,3.72,9.349,12.215-.117-3.284-9.33Z",
    transform: "translate(-2471.256 -1769.295)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 17.073,
    height: 0.903,
    transform: "translate(244.754 182.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M2773.072,2054.977H2756a.193.193,0,0,1-.193-.193v-.9a.193.193,0,0,1,.193-.193h17.073a.193.193,0,0,1,.193.193v.9a.193.193,0,0,1-.193.193m-16.88-.386h16.687v-.518h-16.687Z",
    transform: "translate(-2511.245 -1871.436)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M2786.174,1992.572a.866.866,0,1,1,.985-.858.929.929,0,0,1-.985.858m0-1.33a.486.486,0,1,0,.6.472.548.548,0,0,0-.6-.472",
    transform: "translate(-2538.02 -1814.18)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M2856.7,2278.652h-7.813a.193.193,0,0,1,0-.386h7.813a.193.193,0,0,1,0,.386",
    transform: "translate(-2595.889 -2076.084)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M2745.822,2274.71h-.025l-7.614-.981a.193.193,0,1,1,.049-.383l7.614.98a.193.193,0,0,1-.024.384",
    transform: "translate(-2495.032 -2071.599)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M3107.011,1906.729a.236.236,0,0,1-.232-.195,15.357,15.357,0,0,1,.011-4.379,12.541,12.541,0,0,1,4.1-7.894c5.332-4.578,9.753-5.436,9.939-5.47a.236.236,0,0,1,.278.227c0,.067.1,6.782-3.6,11.475s-10.382,6.215-10.449,6.23a.25.25,0,0,1-.051.005m13.625-17.409a24.464,24.464,0,0,0-9.437,5.3c-4.639,3.983-4.153,10.256-3.991,11.583,1.231-.321,6.742-1.948,9.933-6,3.158-4.012,3.467-9.558,3.495-10.882",
    transform: "translate(-2830.938 -1721.169)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M3109.7,1909.531a.236.236,0,0,1-.185-.382l13.406-16.9a.236.236,0,1,1,.369.293l-13.406,16.9a.235.235,0,0,1-.185.089",
    transform: "translate(-2833.519 -1724.243)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M3150.28,1960.923a.235.235,0,0,1-.232-.2l-.821-5.235a.236.236,0,0,1,.466-.073l.82,5.235a.236.236,0,0,1-.2.269l-.037,0",
    transform: "translate(-2869.75 -1781.703)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M3164.971,1949.793a.237.237,0,0,1-.229-.178l-1.121-4.4a.236.236,0,1,1,.457-.116l1.121,4.4a.236.236,0,0,1-.228.294",
    transform: "translate(-2882.863 -1772.319)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M3203.159,1961.294a.236.236,0,0,1-.021-.47l4.537-.409a.236.236,0,1,1,.042.469l-4.537.409h-.021",
    transform: "translate(-2918.684 -1786.439)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M3148.962,2042.14h-.01l-4.895-.21a.236.236,0,0,1-.226-.245.239.239,0,0,1,.246-.226l4.895.21a.236.236,0,0,1-.01.471",
    transform: "translate(-2864.835 -1860.292)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M3154.85,2071.237a11.165,11.165,0,0,1-3.761-.633.236.236,0,0,1-.112-.347,6.059,6.059,0,0,1,4.413-2.49,6.768,6.768,0,0,1,4.463.835.236.236,0,0,1,.05.33,6.13,6.13,0,0,1-4.162,2.269c-.305.025-.6.036-.89.036m-3.291-.971a11.266,11.266,0,0,0,4.143.465,5.713,5.713,0,0,0,3.653-1.879,7.022,7.022,0,0,0-3.922-.616,5.72,5.72,0,0,0-3.873,2.03",
    transform: "translate(-2871.313 -1884.226)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M3152.419,2080.841a.236.236,0,0,1-.042-.468l8.2-1.486a.236.236,0,0,1,.084.464l-8.2,1.486a.224.224,0,0,1-.042,0",
    transform: "translate(-2872.446 -1894.396)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M3181.766,2071.7a.232.232,0,0,1-.1-.023.235.235,0,0,1-.11-.315l.874-1.806a.236.236,0,1,1,.424.205l-.874,1.806a.235.235,0,0,1-.212.133",
    transform: "translate(-2899.188 -1885.775)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M3202.541,2070.945a.237.237,0,0,1-.223-.313l.522-1.516a.236.236,0,0,1,.446.154l-.522,1.515a.235.235,0,0,1-.222.159",
    transform: "translate(-2918.12 -1885.351)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 8.364,
    height: 5.224,
    transform: "translate(87.422 246.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M991.485,2780.889h-8.364a.193.193,0,0,1-.193-.193v-5.225a.193.193,0,0,1,.193-.193h8.364a.193.193,0,0,1,.193.193v5.225a.193.193,0,0,1-.193.193m-8.171-.386h7.978v-4.838h-7.978Z",
    transform: "translate(-895.699 -2528.99)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M989.284,2780.066l-4.182-2.612h8.364Z",
    transform: "translate(-897.68 -2530.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M987.3,2778.277a.193.193,0,0,1-.1-.03l-4.182-2.612a.193.193,0,0,1,.1-.357h8.364a.193.193,0,0,1,.1.357l-4.182,2.612a.193.193,0,0,1-.1.03m-3.509-2.612,3.509,2.192,3.509-2.192Z",
    transform: "translate(-895.699 -2528.99)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M2355.24,2632.991h0a17.546,17.546,0,0,1,.065-35.091.293.293,0,0,1,.3.3.3.3,0,0,1-.3.3,16.951,16.951,0,0,0-.063,33.9.3.3,0,0,1,0,.6",
    transform: "translate(-2130.399 -2367.352)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M1635.108,1230.894h0l-87.163-.136a.3.3,0,0,1-.3-.3l.04-26.193a.3.3,0,0,1,.3-.3h0a.3.3,0,0,1,.3.3l-.04,25.9,86.567.136.04-25.959a.3.3,0,0,1,.295-.3,16.811,16.811,0,0,0,.055-33.619.3.3,0,0,1-.294-.3l.04-26.386-26.177-.048a.3.3,0,0,1-.3-.291,16.723,16.723,0,0,0-16.782-16.427h-.031a16.723,16.723,0,0,0-16.8,16.379.3.3,0,0,1-.3.29h0l-26.177-.048-.04,26.177a.3.3,0,0,1-.3.3h0a.3.3,0,0,1-.3-.3l.04-26.474a.3.3,0,0,1,.3-.3h0l26.186.048a17.415,17.415,0,0,1,17.384-16.668h.031a17.415,17.415,0,0,1,17.367,16.718l26.187.048a.3.3,0,0,1,.3.3l-.04,26.391a17.406,17.406,0,0,1-.057,34.8l-.04,25.965a.3.3,0,0,1-.3.3",
    transform: "translate(-1410.303 -1026.419)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M1373.107,1647.082h0a17.546,17.546,0,0,1,.065-35.091.3.3,0,0,1,0,.6,16.951,16.951,0,0,0-.063,33.9.3.3,0,0,1,0,.6",
    transform: "translate(-1235.425 -1468.937)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M3740.488,1594.084a3.316,3.316,0,0,0,4.621,1.937c-.348.2-.656.366-.656.366.062.189,1.669,2.593,1.669,2.593l2.86-2.768-2.072-1.982s-.157.26-.372.565a2.834,2.834,0,0,0,.4-2.139,3.322,3.322,0,0,0-6.452,1.43",
    transform: "translate(-3408.484 -1449.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M3872.17,2158.332l4.524,9.107-8.4,3.79s-.639-.343-.083-1.005c.4-.473.848-.633,1.225-1.1s-2.79-7.022-2.79-7.022Z",
    transform: "translate(-3523.504 -1966.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M3865.871,2169.044a.238.238,0,0,1-.111-.028.866.866,0,0,1-.422-.561.961.961,0,0,1,.27-.8,3.626,3.626,0,0,1,.648-.582,3.061,3.061,0,0,0,.554-.493c.058-.51-1.366-3.834-2.8-6.8a.235.235,0,0,1,.079-.3l5.524-3.767a.235.235,0,0,1,.193-.033.239.239,0,0,1,.152.123l4.524,9.107a.236.236,0,0,1-.115.32l-8.4,3.79a.239.239,0,0,1-.1.021m-1.347-9.285c.228.476.858,1.806,1.452,3.16,1.547,3.524,1.351,3.769,1.221,3.93a3.4,3.4,0,0,1-.657.6,3.223,3.223,0,0,0-.571.508.56.56,0,0,0-.168.409.333.333,0,0,0,.1.173l8.052-3.633-4.295-8.646Z",
    transform: "translate(-3521.083 -1964.372)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M3878.359,2231.412l9.086-4.094-1.61-3.266c-1.424.817-2.007,3.153-3.692,3.439-.964.17-2.138-.4-2.952.014.275.767.42,1.315.326,1.45-.4.538-.884.712-1.3,1.248a.774.774,0,0,0,.144,1.208",
    transform: "translate(-3533.842 -2026.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M4167.469,2144.724l7.147,7.234-6.793,6.229s-.714-.125-.394-.929c.229-.574.607-.866.818-1.43s-4.847-5.8-4.847-5.8Z",
    transform: "translate(-3793.925 -1954.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M4165.4,2156a.22.22,0,0,1-.041,0,.865.865,0,0,1-.577-.4.959.959,0,0,1,0-.848,3.611,3.611,0,0,1,.435-.756,3.09,3.09,0,0,0,.371-.641c-.1-.5-2.5-3.214-4.784-5.58a.235.235,0,0,1-.017-.307l4.067-5.307a.235.235,0,0,1,.354-.022l7.148,7.233a.236.236,0,0,1-.009.34l-6.792,6.229a.236.236,0,0,1-.159.062m-4.112-8.409c.364.38,1.38,1.447,2.368,2.546,2.571,2.864,2.462,3.156,2.389,3.35a3.387,3.387,0,0,1-.436.773,3.233,3.233,0,0,0-.384.662.561.561,0,0,0-.03.443.333.333,0,0,0,.148.131l6.51-5.97-6.785-6.867Zm4.308,5.777h0Z",
    transform: "translate(-3791.505 -1951.975)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M4205.367,2204.738l7.348-6.732-2.552-2.6c-1.1,1.222-.919,3.623-2.43,4.422-.863.463-2.156.29-2.8.937.5.643.81,1.118.763,1.276-.208.635-.617.953-.846,1.593a.775.775,0,0,0,.515,1.1",
    transform: "translate(-3831.634 -2000.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M3796.324,1845.326a43.942,43.942,0,0,1,4.9,6.592c.926,1.811,3.773,8.115,5.525,10.588s11.177,12.439,11.177,12.439l-5.333,5.618s-12.054-10.234-13.669-12.556-8.139-10.059-8.139-10.059l-5.565,4.646,6.684,13.708-7.277,3.46s-8.375-15.439-8.788-18.912,9.2-12.514,9.2-12.514Z",
    transform: "translate(-3440.746 -1681.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M3810.182,1878.38a.235.235,0,0,1-.152-.056c-.493-.419-12.1-10.281-13.709-12.6-1.454-2.09-6.987-8.687-7.975-9.862l-5.244,4.377,6.6,13.542a.24.24,0,0,1,.011.181.237.237,0,0,1-.121.135l-7.277,3.46a.236.236,0,0,1-.309-.1c-.343-.632-8.4-15.519-8.814-19-.422-3.55,8.88-12.341,9.276-12.714a.234.234,0,0,1,.1-.056l11.281-3.01a.237.237,0,0,1,.236.071,43.456,43.456,0,0,1,4.935,6.641c.225.439.567,1.153.964,1.979a76.259,76.259,0,0,0,4.544,8.58c1.722,2.431,11.062,12.314,11.156,12.413a.236.236,0,0,1,0,.324l-5.333,5.618a.236.236,0,0,1-.171.073m-21.807-23.086a.236.236,0,0,1,.18.083c.065.078,6.55,7.772,8.153,10.076,1.475,2.121,11.988,11.113,13.457,12.366l5.025-5.294c-1.267-1.342-9.405-9.988-11.045-12.3a76.421,76.421,0,0,1-4.584-8.648c-.4-.824-.737-1.535-.958-1.968a42.468,42.468,0,0,0-4.771-6.434l-11.082,2.957c-.694.66-9.468,9.073-9.088,12.274.377,3.179,7.681,16.824,8.655,18.631l6.86-3.262-6.579-13.494a.236.236,0,0,1,.061-.284l5.565-4.646a.236.236,0,0,1,.151-.055",
    transform: "translate(-3438.333 -1679.146)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M3563.147,1667.369l.261-4.869s11.257,6.488,14.513,5.158c2.6-1.06,5.745-4.844,9.338-4.931,7.915-.192-.462,8.564-6.022,10.165-8.408,2.422-18.09-5.524-18.09-5.524",
    transform: "translate(-3246.939 -1514.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M3741.375,1594.366a3.307,3.307,0,0,1-3.309-2.454h0a3.374,3.374,0,0,1,2.744-3.881,3.681,3.681,0,0,1,2.623.369,2.99,2.99,0,0,1,1.077,4.291c-.064.1-.136.19-.2.279l-.073.1-.015.017-.2.212c-.056.055-.11.1-.161.147l-.043.038a.59.59,0,0,1-.139.1l-.014.008c-.178.117-.4.244-.607.366l-.046.026-.013.007a3.362,3.362,0,0,1-.8.284,3.834,3.834,0,0,1-.818.089m-2.888-2.549a2.963,2.963,0,0,0,3.613,2.039,2.919,2.919,0,0,0,.7-.246l.041-.023c.209-.121.425-.246.593-.358l.017-.01.021-.011a.191.191,0,0,0,.039-.03l.014-.014.052-.046c.044-.039.092-.08.135-.123l.183-.2.068-.09c.064-.084.131-.171.185-.253a2.558,2.558,0,0,0-.928-3.68,3.251,3.251,0,0,0-2.316-.323,2.944,2.944,0,0,0-2.417,3.366",
    transform: "translate(-3406.271 -1447.018)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M3782.152,1621.915a.9.9,0,0,1-.9-.666.823.823,0,0,1,.151-.674,1.042,1.042,0,0,1,1.367-.26.812.812,0,0,1,.216,1.189,1.017,1.017,0,0,1-.6.384,1.054,1.054,0,0,1-.23.026m.086-1.319a.646.646,0,0,0-.139.015.586.586,0,0,0-.349.219.4.4,0,0,0-.077.325.5.5,0,0,0,.617.313.585.585,0,0,0,.349-.219.4.4,0,0,0,.078-.324h0a.39.39,0,0,0-.178-.245.555.555,0,0,0-.3-.083",
    transform: "translate(-3445.671 -1476.385)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M3785.292,1636.574h-.023a.214.214,0,0,1-.156-.095c-.489-.73-1.631-2.45-1.7-2.646a.216.216,0,0,1,.1-.258s.308-.162.646-.361l.014-.008.025-.014.018-.009a2.432,2.432,0,0,0,.572-.345.182.182,0,0,1,.032-.022l.021-.011a.172.172,0,0,0,.039-.03.205.205,0,0,1,.04-.034.957.957,0,0,0,.155-.143l.011-.012a1.632,1.632,0,0,0,.118-.125l.06-.067.069-.09c.064-.084.131-.171.185-.252.211-.3.366-.555.367-.557a.216.216,0,0,1,.334-.044l2.072,1.982a.215.215,0,0,1,0,.311l-2.86,2.769a.216.216,0,0,1-.15.061m-1.375-2.721c.244.4.911,1.419,1.411,2.17l2.513-2.433-1.72-1.645c-.063.1-.145.22-.237.351-.059.089-.13.181-.2.271l-.073.1-.014.017c-.021.022-.04.045-.06.067-.043.049-.088.1-.143.151a1.361,1.361,0,0,1-.21.191.611.611,0,0,1-.127.094l-.005,0a2.838,2.838,0,0,1-.648.389l-.014.008c-.182.107-.352.2-.474.268m-.293-.087h0Z",
    transform: "translate(-3447.653 -1486.616)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M3788.135,1656.169c-.63-4.676,3.4-8.734,1.635-9.243-2.527-.73-2.988.44-2.988.44l3.532-5.456a28.184,28.184,0,0,1,5.067,2.6c5.084,3.008,11.282,15.456,11.282,15.456s-4.2,3.847-7.636,4.789c-7.958,2.584-7.15-1.887-7.15-1.887a9.711,9.711,0,0,1-3.742-6.7",
    transform: "translate(-3450.729 -1496.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M3792.67,1663.558a3.633,3.633,0,0,1-2.456-.737,2.465,2.465,0,0,1-.781-2.069,9.982,9.982,0,0,1-3.726-6.772c-.345-2.564.667-4.923,1.407-6.646.432-1.007.805-1.876.635-2.234a.353.353,0,0,0-.253-.184c-1.795-.519-2.453-.029-2.653.205l-.094.144a.216.216,0,0,1-.382-.2.892.892,0,0,1,.134-.214l3.418-5.28a.215.215,0,0,1,.242-.09,28.157,28.157,0,0,1,5.116,2.621c5.081,3.006,11.111,15.034,11.365,15.545a.216.216,0,0,1-.047.255c-.173.158-4.28,3.893-7.725,4.838a14.121,14.121,0,0,1-4.2.814m-6.588-19.3a5.57,5.57,0,0,1,1.533.248.786.786,0,0,1,.523.415c.253.534-.117,1.4-.629,2.589-.72,1.676-1.7,3.972-1.375,6.418a9.59,9.59,0,0,0,3.646,6.546.217.217,0,0,1,.095.219,2.061,2.061,0,0,0,.627,1.812c.711.617,2.371,1.089,6.244-.168,3.032-.832,6.724-4,7.435-4.634-.716-1.406-6.448-12.453-11.124-15.219a33.641,33.641,0,0,0-4.868-2.526l-2.843,4.391a2.836,2.836,0,0,1,.735-.089",
    transform: "translate(-3448.513 -1493.983)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M3735.992,1560.451c.285.115-1.022-1.2-1.367-1.431-.612-.409-1.737-.493-2.227-1-.9-.924-1.72-2.845-.278-3.644,1.426-.789,2.01,1.385,3.15,1.5.865.084.433-1.17,1.125-1.269,2.32-.334,3.756,3,4.008,4.749.06.415-.429,2.682-1.185,2.464-.458-.132-1.705-.034-1.908-.363-.09-.147.216-.647.014-.974-.234-.379-1.745-.2-1.333-.032",
    transform: "translate(-3400.203 -1416.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M3918.9,1960.362l-3.333-3.636Z",
    transform: "translate(-3568.083 -1783.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M3916.479,1958.179a.236.236,0,0,1-.174-.076l-3.333-3.636a.236.236,0,0,1,.347-.318l3.333,3.636a.236.236,0,0,1-.173.395",
    transform: "translate(-3565.663 -1780.66)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M3548.452,1685.255l1.252-4.6s11.86,5.426,15.292,4.655c3.246-.728,4.894-11.17,8.376-12.061,7.671-1.962.9,17.884-5.818,19.567-9.086,2.278-19.1-7.564-19.1-7.564",
    transform: "translate(-3233.549 -1524.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M3563.15,1691.082c-2.9,0-6.3-1.142-10.011-3.386a43.981,43.981,0,0,1-6.739-5.065.216.216,0,0,1-.059-.213l1.076-3.949a.215.215,0,0,1,.295-.14c.12.053,11.987,5.274,15.305,4.51,1.088-.25,2.268-2.758,3.408-5.184,1.473-3.133,3-6.373,4.963-6.876,2.214-.566,3.066.6,3.391,1.68.636,2.108-.163,6.1-2.037,10.162-1.511,3.278-4.019,7.093-6.522,7.967a9.267,9.267,0,0,1-3.07.494m-16.36-8.677a43.9,43.9,0,0,0,6.578,4.925c3.487,2.107,8.523,4.312,12.709,2.85,1.988-.694,4.391-3.66,6.272-7.74,1.833-3.974,2.624-7.844,2.016-9.857-.394-1.307-1.361-1.773-2.871-1.386-1.769.453-3.315,3.741-4.679,6.642-1.293,2.749-2.409,5.123-3.7,5.421a3.935,3.935,0,0,1-.868.084c-3.916,0-12.881-3.824-14.479-4.52Z",
    transform: "translate(-3231.617 -1522.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M3472,1742.284a16.326,16.326,0,0,0-1.977-.666c-.22-.053-1.919-1.6-2.155-1.631-.324-.043.533,1.661.217,1.692a14.116,14.116,0,0,0-4.274,1.027c-.386.347,3.423.275,3.423.275s-3.906,1.187-3.856,1.431,4.063-.452,4.063-.452a27.4,27.4,0,0,0-3.292,1.773,20.637,20.637,0,0,0,3.257-.98s-1.728,1.475-1.585,1.664,2.155-.907,2.155-.907a3.9,3.9,0,0,0,1.259.249,2.982,2.982,0,0,0,1.668-.17Z",
    transform: "translate(-3156.026 -1585.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M3463.16,1744.052a.262.262,0,0,1-.246-.124c-.17-.227-.026-.481.669-1.149-2.048.7-2.175.609-2.28.532a.273.273,0,0,1-.112-.232c.007-.142.014-.288,1.872-1.226-2.55.384-2.59.189-2.636-.031s-.084-.407,2.416-1.223c-1.862-.04-1.943-.246-2-.38a.308.308,0,0,1,.092-.347c.479-.429,2.95-.923,4.248-1.073-.031-.156-.11-.407-.163-.574-.183-.581-.258-.846-.1-1.029a.309.309,0,0,1,.284-.107c.173.023.432.22,1.3.935.33.272.779.643.9.705a16.439,16.439,0,0,1,2,.675.258.258,0,0,1,.146.319l-1.1,3.3a.258.258,0,0,1-.122.145,3.222,3.222,0,0,1-1.822.2,7.609,7.609,0,0,1-1.211-.22,6.191,6.191,0,0,1-2.131.9m1.546-2.2a.258.258,0,0,1,.167.453c-.4.338-.826.731-1.127,1.035.4-.176.936-.445,1.406-.7.1-.056.191-.07.268.01a5.647,5.647,0,0,0,1.145.209,3.131,3.131,0,0,0,1.429-.106l.986-2.963a14.816,14.816,0,0,0-1.716-.565c-.142-.034-.348-.193-1.09-.8-.221-.183-.51-.42-.735-.6.026.085.052.171.076.244.18.57.268.877.135,1.079a.324.324,0,0,1-.24.144,19.841,19.841,0,0,0-3.615.736c.652.053,1.756.071,2.734.052h.005a.257.257,0,0,1,.075.5c-.978.3-2.019.638-2.755.906.772-.091,1.845-.254,2.842-.427a.257.257,0,0,1,.155.486c-.549.263-1.12.545-1.626.8.446-.15.93-.318,1.392-.485a.255.255,0,0,1,.088-.016m2.679-3.128h0",
    transform: "translate(-3153.324 -1582.929)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M3516.425,1605.4a1.513,1.513,0,0,0-.372,1.172c.03.422,1.637,3.8,2.011,4.817a16.935,16.935,0,0,1-1.987-1.48c-.157.031-.153.774-.086.92a19.792,19.792,0,0,0,1.21,1.794,8.085,8.085,0,0,0,2.956,2.3,28.031,28.031,0,0,1,.212-3.962,8.3,8.3,0,0,1-1.173-1.123,18.927,18.927,0,0,1-2.772-4.441",
    transform: "translate(-3203.928 -1462.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M3517.936,1612.924a.214.214,0,0,1-.065-.01l-.013,0a8.221,8.221,0,0,1-3.046-2.368,19.252,19.252,0,0,1-1.24-1.841,1.8,1.8,0,0,1,.029-1.05.3.3,0,0,1,.211-.172.214.214,0,0,1,.177.044l.142.116c.32.261.824.673,1.253.983-.172-.4-.395-.907-.625-1.427a19.387,19.387,0,0,1-1.145-2.826,1.718,1.718,0,0,1,.434-1.339.216.216,0,0,1,.35.064,18.679,18.679,0,0,0,2.74,4.391,8.14,8.14,0,0,0,1.138,1.09.216.216,0,0,1,.084.194,33.508,33.508,0,0,0-.249,3.818.216.216,0,0,1-.178.338m.183-.315h0Zm-.118-.107h0Zm-4.053-4.457a1.668,1.668,0,0,0,.019.48,20.37,20.37,0,0,0,1.179,1.743,8.782,8.782,0,0,0,2.529,2.106,32.7,32.7,0,0,1,.247-3.531,8.411,8.411,0,0,1-1.112-1.081,19.1,19.1,0,0,1-2.646-4.146,1.487,1.487,0,0,0-.118.724,27.83,27.83,0,0,0,1.109,2.681c.377.852.734,1.656.889,2.076a.216.216,0,0,1-.3.267,13.933,13.933,0,0,1-1.8-1.318",
    transform: "translate(-3201.706 -1460.713)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M1484.749,252.967a17.676,17.676,0,0,0-16.573-17.634V209.519H1441.5c.005-.17.026-.337.026-.508a17.035,17.035,0,0,0-34.07,0c0,.172.021.338.026.508h-26.672v25.794a17.668,17.668,0,0,0,0,35.308v26.253h87.363V270.6a17.676,17.676,0,0,0,16.573-17.634",
    transform: "translate(-1242.809 -174.94)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M2054.308,2189.9l1.076,9.368,8.714-.036s.416-.545-.323-.9c-.527-.251-.978-.211-1.486-.468s-1.812-7.533-1.812-7.533Z",
    transform: "translate(-1872.001 -1995.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M2053.1,2197.2a.223.223,0,0,1-.221-.2l-1.076-9.368a.222.222,0,0,1,.237-.248l6.168.434a.223.223,0,0,1,.2.183c.6,3.36,1.4,7.019,1.711,7.382a2.846,2.846,0,0,0,.678.211,3.441,3.441,0,0,1,.786.246.91.91,0,0,1,.548.586.819.819,0,0,1-.143.648.223.223,0,0,1-.176.088l-8.715.037Zm-.824-9.351,1.023,8.9,8.384-.035a.311.311,0,0,0,.018-.188c-.033-.132-.184-.229-.3-.286a3.064,3.064,0,0,0-.691-.213,3.21,3.21,0,0,1-.8-.256c-.155-.078-.414-.208-1.215-4.016-.317-1.508-.595-3.01-.686-3.507Z",
    transform: "translate(-1869.713 -1993.27)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M2071.815,2261.825l-9.423.043.1-3.442c1.546.144,2.964,1.925,4.526,1.51.9-.233,1.683-1.183,2.545-1.146.065.768.155,1.3.289,1.376.552.307,1.04.265,1.609.563a.732.732,0,0,1,.35,1.1",
    transform: "translate(-1879.367 -2058.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M1875.45,2189.9l-1.076,9.368-8.714-.036s-.416-.545.323-.9c.527-.251.977-.211,1.486-.468s1.812-7.533,1.812-7.533Z",
    transform: "translate(-1699.987 -1995.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M1872.083,2197.2h0l-8.714-.037a.222.222,0,0,1-.177-.088.817.817,0,0,1-.143-.648.91.91,0,0,1,.547-.586,3.445,3.445,0,0,1,.786-.246,2.858,2.858,0,0,0,.678-.211c.308-.363,1.109-4.022,1.711-7.382a.222.222,0,0,1,.2-.183l6.168-.434a.222.222,0,0,1,.237.248L1872.3,2197a.223.223,0,0,1-.221.2m-8.582-.481,8.384.035,1.023-8.9-5.728.4c-.09.5-.368,2-.685,3.507-.8,3.808-1.06,3.938-1.215,4.016a3.215,3.215,0,0,1-.8.256,3.038,3.038,0,0,0-.69.213c-.121.057-.272.154-.305.286a.316.316,0,0,0,.018.188",
    transform: "translate(-1697.696 -1993.27)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M1861.62,2261.825l9.423.043-.1-3.442c-1.546.144-2.964,1.925-4.526,1.51-.9-.233-1.683-1.183-2.545-1.146-.065.768-.156,1.3-.289,1.376-.552.307-1.04.265-1.609.563a.732.732,0,0,0-.35,1.1",
    transform: "translate(-1696.297 -2058.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M1972.607,1519.276a2.934,2.934,0,1,1,2.895,2.915,2.906,2.906,0,0,1-2.895-2.915",
    transform: "translate(-1797.55 -1381.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M1973.563,1520.405h-.043a3.135,3.135,0,0,1-2.2-.927,3.029,3.029,0,0,1,.058-4.342,3.1,3.1,0,1,1,2.182,5.269m0-5.752a2.752,2.752,0,0,0-1.911.762,2.644,2.644,0,0,0-.051,3.792,2.753,2.753,0,0,0,1.928.813,2.684,2.684,0,1,0,.072-5.366h-.038m-2.931,2.644h0Z",
    transform: "translate(-1795.571 -1379.886)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M1964.447,1544.717a.691.691,0,0,1,.675-.622,4.535,4.535,0,0,1-.017,1.262.65.65,0,0,1-.658-.64",
    transform: "translate(-1790.115 -1407.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M1963.125,1543.569h0a.875.875,0,0,1-.6-.246.8.8,0,0,1-.248-.589.875.875,0,0,1,.842-.81.2.2,0,0,1,.2.112c.028.061.136,1.308-.067,1.485a.193.193,0,0,1-.127.048m-.151-1.214a.429.429,0,0,0-.315.384.419.419,0,0,0,.131.308.478.478,0,0,0,.186.112,8.013,8.013,0,0,0,0-.8m-.507.381h0Zm.7-.431h0",
    transform: "translate(-1788.134 -1405.086)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M1964.447,1544.717a.691.691,0,0,1,.675-.622,4.535,4.535,0,0,1-.017,1.262.65.65,0,0,1-.658-.64",
    transform: "translate(-1790.115 -1407.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M1963.125,1543.569h0a.875.875,0,0,1-.6-.246.8.8,0,0,1-.248-.589.875.875,0,0,1,.842-.81.2.2,0,0,1,.2.112c.028.061.136,1.308-.067,1.485a.193.193,0,0,1-.127.048m-.151-1.214a.429.429,0,0,0-.315.384.419.419,0,0,0,.131.308.478.478,0,0,0,.186.112,8.013,8.013,0,0,0,0-.8m-.507.381h0Zm.7-.431h0",
    transform: "translate(-1788.134 -1405.086)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M2037.284,1540.449a.2.2,0,0,1-.177-.112c-.029-.061-.164-1.3.041-1.485a.193.193,0,0,1,.129-.05h0a.843.843,0,0,1,.859.82h0a.875.875,0,0,1-.828.824l-.028,0m.146-1.24a7.916,7.916,0,0,0,.017.8.43.43,0,0,0,.308-.39.444.444,0,0,0-.325-.414",
    transform: "translate(-1856.262 -1402.243)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M1895.8,1841.228l-1.765,36.222,7.452.627,1.97-28.985,4.806,28.75,7.2-1.452-4.753-34.661Z",
    transform: "translate(-1725.947 -1677.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M1899.5,1876.291h-.016l-7.452-.628a.193.193,0,0,1-.177-.2l1.766-36.221a.194.194,0,0,1,.2-.183l14.914.5a.193.193,0,0,1,.184.166l4.753,34.661a.193.193,0,0,1-.153.215l-7.2,1.452a.193.193,0,0,1-.228-.157l-4.535-27.129-1.859,27.345a.193.193,0,0,1-.192.18m-7.25-1,7.071.6,1.956-28.79a.193.193,0,0,1,.183-.179.191.191,0,0,1,.2.161l4.773,28.553,6.831-1.377-4.706-34.32-14.561-.489Z",
    transform: "translate(-1723.968 -1675.852)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M1879.7,1555.842s-2.435-.033-3.4.065-3.906-2.917-3.906-2.917l-4.812,3.62s2.462,5.168,2.784,6.1-.738,14.676.468,15.5,1.517.274,3.9.56,3.817,2.687,7.629,2.028a12.466,12.466,0,0,0,5.864-2.507l-1.548-13.153,4.5-6.531-4.086-5.328-3.89,3.116Z",
    transform: "translate(-1701.845 -1415.172)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M1950.228,1480.815c-.422-1.279-2.3-.168-3.471-.166-.711,0-.9-.65-1.52-.9a5.375,5.375,0,0,0-1.245-.108,3.329,3.329,0,0,1-2.3-2.113c-.289-.829.024-2.5,1.073-2.7.873-.166,1.128,1.112,2.01,1.132.759.017,1.049-.923,1.772-1,1.377-.146,1.866.892,2.834,1.522.32.208.736.178,1.039.416a3.293,3.293,0,0,1,.958,3.139c-.023.078-.434.873-.507.846-.2-.076-.577.143-.645-.062",
    transform: "translate(-1769.286 -1343.927)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M1987.24,1577.837l.21.7a2.112,2.112,0,0,0,1.491.625,1.429,1.429,0,0,0,1.262-.589l.209-.815a4.017,4.017,0,0,1-1.656.391,8.62,8.62,0,0,1-1.516-.307",
    transform: "translate(-1810.885 -1437.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M1986.952,1577.37a2.3,2.3,0,0,1-1.624-.69.2.2,0,0,1-.041-.073l-.21-.7a.193.193,0,0,1,.241-.24,8.472,8.472,0,0,0,1.476.3,3.845,3.845,0,0,0,1.557-.373.193.193,0,0,1,.27.222l-.209.816a.191.191,0,0,1-.019.048,1.614,1.614,0,0,1-1.429.686h-.011m-1.31-.919a1.951,1.951,0,0,0,1.319.533,1.275,1.275,0,0,0,1.085-.474l.106-.412a3.511,3.511,0,0,1-1.391.257,7.859,7.859,0,0,1-1.214-.22Z",
    transform: "translate(-1808.906 -1435.758)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M1842.521,1359.462s-2.622-3.093-2.821-4.984.145-10.826.145-10.826,1.212-3.3.9-3.493-2.148,2.712-2.148,2.712l-1.818.092-.344,3.653s-2.052,5.634-1.24,8.7a44.26,44.26,0,0,0,2.96,7.2Z",
    transform: "translate(-1672.16 -1221.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M1836.164,1360.678a.189.189,0,0,1-.046-.005.193.193,0,0,1-.125-.1,44.747,44.747,0,0,1-2.975-7.236c-.8-3.02,1.073-8.338,1.236-8.791l.342-3.629a.193.193,0,0,1,.182-.174l1.718-.087c1.89-2.982,2.207-2.784,2.359-2.688.133.083.443.278-.811,3.694-.022.575-.335,8.968-.145,10.768s2.75,4.849,2.776,4.879a.193.193,0,0,1-.036.283l-4.365,3.052a.193.193,0,0,1-.111.035m-1.2-19.558-.328,3.487a.194.194,0,0,1-.011.048c-.02.056-2.022,5.612-1.234,8.584a42.848,42.848,0,0,0,2.844,6.961l4.012-2.805c-.549-.672-2.552-3.227-2.73-4.925-.2-1.882.13-10.488.144-10.853a.194.194,0,0,1,.012-.059,19.5,19.5,0,0,0,.938-3.151,18.292,18.292,0,0,0-1.842,2.54.192.192,0,0,1-.153.09Z",
    transform: "translate(-1670.168 -1219.193)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M2087.989,1360.818s3.873-3.952,4.568-5.546,2.568-10.279,2.568-10.279-1.115-4.865-.751-4.844c.885.049,1.878,3,1.878,3a14.369,14.369,0,0,1,2.906-.029c-.068.226-1.471,12.343-2.4,14.9s-6.808,8.092-6.808,8.092Z",
    transform: "translate(-1902.693 -1221.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M2087.974,1364.327a.2.2,0,0,1-.044,0,.192.192,0,0,1-.137-.121l-1.966-5.295a.193.193,0,0,1,.043-.2c.038-.039,3.856-3.945,4.53-5.488.654-1.5,2.405-9.546,2.547-10.2-.049-.216-.278-1.232-.479-2.266-.473-2.43-.342-2.585-.255-2.688a.231.231,0,0,1,.191-.084c.9.05,1.745,2.264,2,2.994,2.728-.2,2.852-.048,2.919.035a.213.213,0,0,1,.038.2c-.014.061-.091.661-.188,1.42-.44,3.422-1.469,11.436-2.212,13.486-.93,2.567-6.616,7.939-6.857,8.167a.2.2,0,0,1-.132.052m-1.742-5.44,1.821,4.906c1.056-1.016,5.747-5.605,6.548-7.816.729-2.01,1.754-9.994,2.192-13.4.095-.739.143-1.113.17-1.3a24.557,24.557,0,0,0-2.676.1.193.193,0,0,1-.2-.131c-.364-1.083-1.064-2.585-1.579-2.837a33.537,33.537,0,0,0,.823,4.573.2.2,0,0,1,0,.084c-.077.355-1.886,8.721-2.58,10.315-.652,1.494-3.933,4.909-4.522,5.516m10.762-17.8,0,.015,0-.015",
    transform: "translate(-1900.713 -1219.24)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M1939.618,1719.862h-.009a.193.193,0,0,1,0-.385h.01c.247,0,6.245-.052,8.439-4.23a.193.193,0,0,1,.341.179c-2.3,4.38-8.513,4.436-8.783,4.436",
    transform: "translate(-1767.307 -1562.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M1995.372,1802.581h-.083a.193.193,0,0,1,0-.385h0c1.15.014,4.249-.194,4.764-1.324a.193.193,0,0,1,.351.16c-.677,1.487-4.408,1.55-5.036,1.55",
    transform: "translate(-1818.046 -1640.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M1109.893,1129.869l2.778,16.058,9.216.1s.448-.57-.327-.955c-.553-.274-1.03-.239-1.564-.519s-2.654-14.989-2.654-14.989Z",
    transform: "translate(-1011.397 -1029.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M1119.468,1143.847h0l-9.216-.1a.235.235,0,0,1-.229-.2l-2.778-16.058a.236.236,0,0,1,.223-.276l7.449-.3a.237.237,0,0,1,.243.2c.776,5.385,2.148,14.1,2.566,14.833a3.1,3.1,0,0,0,.7.225,3.628,3.628,0,0,1,.827.273.962.962,0,0,1,.569.628.866.866,0,0,1-.161.683.236.236,0,0,1-.185.09m-9.017-.573,8.881.1a.332.332,0,0,0,.022-.2c-.033-.14-.191-.245-.318-.307a3.218,3.218,0,0,0-.727-.237,3.393,3.393,0,0,1-.842-.284c-.185-.1-.438-.229-1.651-7.771-.509-3.169-.975-6.349-1.1-7.183l-6.968.281Z",
    transform: "translate(-1008.978 -1026.907)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M1141.767,1278.437l-9.965-.108-.5-3.638c1.632.178,3.764,2.084,5.422,1.671.952-.231,1.649-1.215,2.56-1.162a2.426,2.426,0,0,0,.433,1.451c.578.334,1.1.3,1.693.621a.774.774,0,0,1,.352,1.165",
    transform: "translate(-1030.91 -1161.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M967.157,1119.045l-2.25,17.019,9.216.1s.448-.57-.327-.955c-.553-.274-1.03-.239-1.564-.519s2.374-15.95,2.374-15.95Z",
    transform: "translate(-879.277 -1019.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M971.7,1133.983h0l-9.216-.1a.236.236,0,0,1-.231-.267l2.25-17.019a.236.236,0,0,1,.224-.2l7.449-.3a.236.236,0,0,1,.241.278c-1.044,5.624-2.6,14.737-2.429,15.732a3.216,3.216,0,0,0,.665.21,3.631,3.631,0,0,1,.828.273.962.962,0,0,1,.569.629.865.865,0,0,1-.161.683.236.236,0,0,1-.185.09m-8.948-.572,8.812.1a.333.333,0,0,0,.022-.2c-.033-.14-.191-.244-.318-.307a3.217,3.217,0,0,0-.727-.236,3.394,3.394,0,0,1-.842-.285c-.238-.125-.485-.254.863-8.327.551-3.3,1.154-6.6,1.334-7.584l-6.956.28Z",
    transform: "translate(-876.858 -1017.043)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M970.57,1278.437l-9.965-.108.165-3.638c1.632.178,3.1,2.084,4.761,1.671.952-.231,1.8-1.224,2.71-1.17.056.813.143,1.373.283,1.459.578.334,1.1.3,1.693.621a.774.774,0,0,1,.352,1.165",
    transform: "translate(-875.357 -1161.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M1106.872,403.415c-2.028,2.508-4.259,3.226-6.683,5.454-1.177,1.082-2.468,2.309-2.559,3.9-.081,1.425.8,3.349,2.226,3.349,4.015,0,10.814-8.318,11.783-10.013,2.859-5,1.793-13.574,2.472-14.517.178-.247,2.478-3.458,2.472-4.369,0-.283-1.667,1.736-1.564,1.452.456-1.259,1.158-3.555.933-3.589-.374-.056-1.747,3.208-1.747,3.208s.729-4.389.242-4.363-1.506,4.1-1.506,4.1.146-3.938-.21-3.817-.911,4.763-.911,4.763-1.149-2.345-1.488-1.961.408,3.644.408,3.644-2.693,11.3-3.868,12.757",
    transform: "translate(-1000.217 -349.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M1097.867,414.33h0a1.948,1.948,0,0,1-1.422-.666,4.106,4.106,0,0,1-1-2.888c.1-1.717,1.5-3,2.621-4.036a24.5,24.5,0,0,1,2.951-2.255,15.678,15.678,0,0,0,3.712-3.178h0c1.1-1.358,3.635-11.865,3.82-12.636-.236-1.033-.716-3.363-.355-3.772a.308.308,0,0,1,.28-.1c.361.049.878.879,1.238,1.546.523-4.149.841-4.257.964-4.3a.241.241,0,0,1,.223.036c.1.078.264.2.272,2.142,0,.089,0,.178,0,.266.051-.176.106-.359.162-.54.619-2,.888-2.183,1.111-2.195a.277.277,0,0,1,.221.095c.258.288.126,1.774-.045,3.057.957-2.056,1.248-2.013,1.369-1.994a.23.23,0,0,1,.163.111c.175.295-.347,1.979-.683,2.982l.01-.01c.856-.924.988-1.032,1.169-.962a.215.215,0,0,1,.136.2c.006.945-2.089,3.9-2.509,4.483a10.347,10.347,0,0,0-.269,2.9c-.1,3.266-.249,8.2-2.192,11.6-.976,1.708-7.852,10.11-11.95,10.111m10.6-29.131a13.1,13.1,0,0,0,.472,3.429.2.2,0,0,1,0,.088c-.11.463-2.717,11.363-3.906,12.834a16,16,0,0,1-3.8,3.254,24.179,24.179,0,0,0-2.908,2.22c-1.073.986-2.408,2.213-2.5,3.773a3.749,3.749,0,0,0,.892,2.6,1.55,1.55,0,0,0,1.14.544h0c2.086,0,4.9-2.346,6.9-4.315a36.083,36.083,0,0,0,4.717-5.6c1.895-3.313,2.043-8.191,2.141-11.418.057-1.863.095-2.773.342-3.116a24.172,24.172,0,0,0,2.316-3.782c-.171.175-.368.388-.514.545-.622.672-.673.726-.839.626a.206.206,0,0,1-.08-.258,26.389,26.389,0,0,0,.922-3.064,23.392,23.392,0,0,0-1.376,2.824.194.194,0,0,1-.369-.107,21.07,21.07,0,0,0,.389-4.051,19.6,19.6,0,0,0-1.275,3.864.194.194,0,0,1-.381-.054,28,28,0,0,0-.033-3.335,38.951,38.951,0,0,0-.7,4.311.194.194,0,0,1-.366.062,7.034,7.034,0,0,0-1.189-1.874m-3.585,16.229h0Z",
    transform: "translate(-998.228 -347.874)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M1144.346,616.185l-3.95-5.14s-3.5,2.092-4.36,3.73-.5,4.892-.5,4.892,2.2,2.416,3.483,1.414,5.329-4.9,5.329-4.9",
    transform: "translate(-1034.694 -556.819)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M1063.648,540.533a3.453,3.453,0,0,1-2.227-.8,3.237,3.237,0,0,1-1.165-2.226,3.523,3.523,0,0,1,5.756-2.883,3.236,3.236,0,0,1,1.165,2.225,3.463,3.463,0,0,1-3.176,3.667q-.177.017-.352.017m.134-6.323q-.156,0-.313.015a3.076,3.076,0,0,0-2.827,3.25,2.852,2.852,0,0,0,1.027,1.961,3.137,3.137,0,0,0,5.122-2.554,2.852,2.852,0,0,0-1.027-1.96,3.071,3.071,0,0,0-1.982-.711",
    transform: "translate(-966.154 -486.45)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M1067.534,569.388a.946.946,0,0,1-.6-.215.842.842,0,0,1-.3-.578.916.916,0,0,1,.85-.962.95.95,0,0,1,.7.21.843.843,0,0,1,.305.579.917.917,0,0,1-.849.962c-.031,0-.062,0-.093,0m.035-1.372-.057,0a.529.529,0,0,0-.5.544h0a.458.458,0,0,0,.166.314.563.563,0,0,0,.412.122.53.53,0,0,0,.5-.544.459.459,0,0,0-.167-.314.555.555,0,0,0-.354-.124",
    transform: "translate(-971.966 -517.255)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M1060.714,608.628h-.107a3.759,3.759,0,0,1-3.322-2.112.194.194,0,0,1,.106-.257l1.606-.643.237-2.254a.194.194,0,0,1,.209-.173l2.5.218a.193.193,0,0,1,.177.193c0,.074.068,1.059.117,1.761l1.416.914a.194.194,0,0,1,.08.219,3.175,3.175,0,0,1-3.015,2.135m-2.982-2.09a3.373,3.373,0,0,0,2.885,1.7,2.746,2.746,0,0,0,2.69-1.725l-1.366-.882a.194.194,0,0,1-.088-.149c-.017-.243-.089-1.281-.115-1.706l-2.139-.187-.23,2.181a.193.193,0,0,1-.12.159Zm1.445-.787h0Z",
    transform: "translate(-963.443 -549.658)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M1012.075,521.123c-.07.1.312-.084.412-.2.27-.308.08-1.119.3-1.319.812-.742,2.728-.374,3.215-1.408.159-.336-.912-1.684-1.536-1.779-.692-.105-1.438-1.1-2.949-.78-1.112.233-1.489.961-2.437,1.828-1.174,1.073.07,1.713-2.218,2.876-1.566.8-2.406,2.735-1.633,3.583,1.535,1.682-.313,4.352,1.17,3.924a38.208,38.208,0,0,0,4.972-2.047c1.493-.911-.79-4.217-.552-5.087.251-.918,1.64-.164,1.259.408",
    transform: "translate(-915.753 -469.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M1111.391,545.078c1.051,1.385.349,3.513-.78,4.642-.239.239-.863.15-1.024.39a7.645,7.645,0,0,0,.1,1.877,18.626,18.626,0,0,0,3.924,1.827c.2-.051.677-1.446.707-1.682.218-1.742-1.442-1.824-1.95-3.095-.379-.947.3-2.377.121-3.437-.109-.66-.815-1.342-1.121-.731-.048.1-.068.084.024.207",
    transform: "translate(-1011.096 -496.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M971.74,829.51l12.371-.688,4.343,26.689s-7.2.864-11.568,1.3-9.137.311-10.049-.506,2.769-14.3,3.249-17.7,1.654-9.088,1.654-9.088",
    transform: "translate(-880.905 -755.269)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M1009.743,641.649l4.022-1.372a6.042,6.042,0,0,0,3.559,1.627,2.773,2.773,0,0,0,2.609-1.777s1.841.543,2.493.843c.534.678,1.081,3.1,1.568,5.224.579,2.516-1.148,8.512-1.148,8.512l-12.055,1.013-1.427-9.137Z",
    transform: "translate(-919.789 -583.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M1008.8,653.924a.194.194,0,0,1-.191-.164l-1.427-9.137a.189.189,0,0,1,0-.045l.379-4.932a.194.194,0,0,1,.13-.168l4.022-1.372a.193.193,0,0,1,.2.045,5.885,5.885,0,0,0,3.428,1.571,2.589,2.589,0,0,0,2.422-1.649.194.194,0,0,1,.237-.121c.076.022,1.862.55,2.519.853a.194.194,0,0,1,.071.056c.546.693,1.063,2.943,1.563,5.119l.042.181c.583,2.535-1.079,8.362-1.15,8.609a.193.193,0,0,1-.17.139l-12.055,1.013h-.016m-1.232-9.338,1.4,8.936,11.741-.986c.244-.88,1.624-6.049,1.109-8.287l-.042-.181a21.337,21.337,0,0,0-1.463-4.93c-.547-.241-1.81-.629-2.26-.765a2.943,2.943,0,0,1-2.639,1.737h-.083a6.08,6.08,0,0,1-3.6-1.6l-3.791,1.293Z",
    transform: "translate(-917.8 -581.332)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M901.718,722.759l4.5,2.9s-2.69,2.464-3.106,3.472c.095,1.948,5.557,4.456,5.557,4.456s2.876.715,3.017,1.163-2.452.628-2.452.628,1.721,3.489,1.571,3.835-2.168-2.451-2.168-2.451,2.281,3.817,1.791,4.211-2.263-3.551-2.263-3.551,1.53,3.772,1.131,3.709-1.651-3.384-1.651-3.384.793,2.783.371,2.808-.857-3.228-1.453-4.516-8.423-3.369-9.02-5.883,4.172-7.4,4.172-7.4",
    transform: "translate(-817.847 -658.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M907.331,739.337a.246.246,0,0,1-.04,0c-.131-.021-.323-.052-.961-1.465a1.323,1.323,0,0,1-.061.769.283.283,0,0,1-.216.123c-.365.021-.525-.521-.932-2.21a15.606,15.606,0,0,0-.708-2.418c-.21-.453-1.727-1.149-3.193-1.821-2.559-1.174-5.461-2.5-5.84-4.1-.614-2.588,4.024-7.373,4.222-7.576a.194.194,0,0,1,.243-.027l4.5,2.9a.193.193,0,0,1,.026.306,20.31,20.31,0,0,0-3.04,3.362c.143,1.493,3.938,3.554,5.425,4.239,1.115.278,2.987.811,3.137,1.288a.31.31,0,0,1-.043.273c-.242.355-1.523.518-2.294.584.77,1.577,1.594,3.405,1.449,3.741a.238.238,0,0,1-.194.145c-.075.008-.228.025-.819-.643.872,1.751.8,2.158.58,2.331a.321.321,0,0,1-.283.06c-.237-.057-.555-.453-.882-.974.243.854.149.972.107,1.025a.236.236,0,0,1-.186.09m-1.141-4.1a.194.194,0,0,1,.177.114,13.6,13.6,0,0,0,1.966,3.444,14.2,14.2,0,0,0-1.837-3.925.194.194,0,0,1,.323-.213,23.957,23.957,0,0,0,1.762,2.209,33.145,33.145,0,0,0-1.5-3.393.194.194,0,0,1,.16-.279,7.2,7.2,0,0,0,2.255-.409,11.112,11.112,0,0,0-2.854-1,.189.189,0,0,1-.034-.012c-.227-.1-5.57-2.581-5.67-4.623a.192.192,0,0,1,.014-.083,17.125,17.125,0,0,1,2.97-3.37l-4.158-2.678c-.7.743-4.53,4.926-4.013,7.1.335,1.411,3.268,2.756,5.624,3.836,1.93.885,3.126,1.456,3.383,2.01a15.49,15.49,0,0,1,.733,2.49,16.121,16.121,0,0,0,.477,1.727,13.347,13.347,0,0,0-.49-2.375.194.194,0,0,1,.367-.121,26.384,26.384,0,0,0,1.263,2.9,32.6,32.6,0,0,0-1.1-3.079.194.194,0,0,1,.179-.266m-.1,3.148h0Zm2.557-1.217h0Z",
    transform: "translate(-815.868 -656.632)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M939.232,656.96l5.466,4.4s8.752-6.324,5.182-9.4c-4.391-3.782-10.647,5-10.647,5",
    transform: "translate(-855.881 -593.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M1032.227,809.031v-2.124l10.825-.812-.161,2.255Z",
    transform: "translate(-940.623 -734.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M1030.239,807.238a.194.194,0,0,1-.194-.194V804.92a.194.194,0,0,1,.179-.193l10.825-.812a.194.194,0,0,1,.208.207l-.161,2.255a.193.193,0,0,1-.181.179l-10.664.682h-.012m.193-2.138v1.738l10.289-.658.133-1.862Z",
    transform: "translate(-938.635 -732.572)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M2763.921,1193.4l2.107,11.208-9.216.1s-.448-.57.327-.955c.554-.274,1.03-.239,1.564-.519s-1.244-8.368-1.244-8.368Z",
    transform: "translate(-2512.045 -1087.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M2754.39,1202.527a.236.236,0,0,1-.186-.09.864.864,0,0,1-.161-.683.962.962,0,0,1,.569-.628,3.624,3.624,0,0,1,.827-.273,3.127,3.127,0,0,0,.687-.22c.17-.564-.529-4.536-1.319-8.132a.236.236,0,0,1,.178-.28l6.461-1.471a.235.235,0,0,1,.284.186l2.107,11.208a.236.236,0,0,1-.229.279l-9.216.1Zm.927-9.9c.127.588.474,2.221.774,3.859.787,4.285.516,4.426.3,4.54a3.39,3.39,0,0,1-.842.285,3.206,3.206,0,0,0-.727.236c-.128.063-.287.168-.319.31a.332.332,0,0,0,.023.2l8.8-.1-2.01-10.691Z",
    transform: "translate(-2509.622 -1085.073)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M2752.555,1284.228l9.965-.108-.166-3.638c-1.632.177-3.1,2.083-4.761,1.671-.951-.231-1.8-1.223-2.709-1.17-.056.813-.144,1.373-.283,1.459-.578.334-1.1.3-1.693.622a.774.774,0,0,0-.353,1.165",
    transform: "translate(-2508.155 -1166.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M2642.135,1193.4l.6,11.208-9.216.1s-.448-.57.327-.955c.553-.274,1.03-.239,1.564-.519s.258-8.368.258-8.368Z",
    transform: "translate(-2399.697 -1087.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M2631.1,1202.527a.236.236,0,0,1-.185-.09.864.864,0,0,1-.162-.683.963.963,0,0,1,.569-.629,3.648,3.648,0,0,1,.828-.273,3.076,3.076,0,0,0,.7-.228c.26-.483.288-4.5.163-8.167a.235.235,0,0,1,.183-.238l6.461-1.471a.236.236,0,0,1,.288.217l.6,11.208a.235.235,0,0,1-.233.248l-9.216.1Zm2.392-9.89c.017.557.063,2.222.065,3.892,0,4.257-.272,4.4-.456,4.5a3.388,3.388,0,0,1-.842.285,3.214,3.214,0,0,0-.727.236c-.127.063-.285.167-.318.307a.331.331,0,0,0,.022.2l8.832-.1-.577-10.683Z",
    transform: "translate(-2397.274 -1085.073)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M2629.249,1284.228l9.965-.108-.166-3.638c-1.632.177-3.1,2.083-4.761,1.671-.951-.231-1.8-1.223-2.71-1.17-.056.813-.143,1.373-.283,1.459-.578.334-1.1.3-1.693.622a.775.775,0,0,0-.352,1.165",
    transform: "translate(-2395.791 -1166.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M2756.7,524.037a3.265,3.265,0,0,1-1.956-.667,2.828,2.828,0,1,1,3.379-4.5,3.239,3.239,0,0,1,1.253,1.963,2.642,2.642,0,0,1-2.4,3.2c-.093.009-.186.013-.279.013m-.534-5.447a2.334,2.334,0,0,0-1.895.905,2.579,2.579,0,0,0,.707,3.562,2.849,2.849,0,0,0,1.965.578,2.253,2.253,0,0,0,2.051-2.733,2.848,2.848,0,0,0-1.1-1.726,2.883,2.883,0,0,0-1.724-.588",
    transform: "translate(-2509.087 -472.215)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M2809.506,552.429a.726.726,0,0,0-.139-1,.683.683,0,0,0-.973.14.726.726,0,0,0,.139,1,.682.682,0,0,0,.972-.141",
    transform: "translate(-2559.04 -502.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M2806.956,550.907a.871.871,0,0,1-.535-.185.923.923,0,0,1-.177-1.268.88.88,0,0,1,.59-.355.87.87,0,0,1,.658.176.923.923,0,0,1,.177,1.268.881.881,0,0,1-.713.364m0-1.427a.5.5,0,0,0-.068,0,.493.493,0,0,0-.33.2.53.53,0,0,0,.1.729.484.484,0,0,0,.367.1.491.491,0,0,0,.329-.2h0a.531.531,0,0,0-.1-.729.485.485,0,0,0-.3-.1",
    transform: "translate(-2557.046 -500.362)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M2767.284,578.5c-.476-.079-1.291-.272-1.291-.272-.09.146-.717,1.9-.717,1.9s.007,1,1.453,1.181a1.825,1.825,0,0,0,1.919-.672l.342-2.34a7.077,7.077,0,0,1-1.706.2",
    transform: "translate(-2519.875 -526.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M2765.116,579.527a3.35,3.35,0,0,1-.413-.026c-1.6-.2-1.624-1.361-1.624-1.373a.2.2,0,0,1,.011-.067c.148-.416.641-1.785.734-1.937a.194.194,0,0,1,.211-.088c.008,0,.814.192,1.278.269a6.578,6.578,0,0,0,1.631-.2.195.195,0,0,1,.236.218l-.342,2.34a.206.206,0,0,1-.022.067,1.877,1.877,0,0,1-1.7.8m-1.645-1.373c.016.15.152.82,1.28.96a1.7,1.7,0,0,0,1.708-.547l.3-2.022a5.542,5.542,0,0,1-1.5.146h0c-.355-.059-.886-.178-1.147-.238-.12.295-.39,1.03-.631,1.7",
    transform: "translate(-2517.873 -524.912)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M2762.377,490.563c.238.262-.184-.28-.33-.4-.488-.4-1.04-.8-1.563-1.16-1.236-.852-4.082-3.468-1.371-4.766,1.466-.7,1.272,1.16,2.247,1.4.638.157,1.219-.455,1.781-.293,1.566.453.93,1.74,1.742,2.7.4.475,1.273.614,1.032,1.447s-2,2.549-2.852,2.6c-.46.027.843-1.074.659-1.534-.337-.844-1.472-.135-1.345.005",
    transform: "translate(-2513.226 -441.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M2540.4,528.1l.14-6.737s4.586,5.288,6.372,6c1.7.682,13.286,1,13.286,1s-.134,3.958-1.474,5.054a5.016,5.016,0,0,1-3.152.981s-7.069.21-9.915-1.261c-2.807-1.45-5.257-5.045-5.257-5.045",
    transform: "translate(-2314.956 -475.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M2648.486,876.373l7.173-.584s-.839-14.587-.839-15.84,2.7,16.017,2.7,16.017l8.8-.612s-3.326-12.827-3.473-15.7-1.031-16.2-1.031-16.2.884-1.989-3.167-2.652a33.793,33.793,0,0,0-8.911.074s-2.136,11.488-1.989,14.655.736,20.842.736,20.842",
    transform: "translate(-2412.772 -765.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M2646.485,874.59a.194.194,0,0,1-.195-.188c-.006-.177-.591-17.709-.736-20.839-.146-3.153,1.9-14.23,1.992-14.7a.194.194,0,0,1,.162-.157,34.268,34.268,0,0,1,8.972-.074c1.7.279,2.785.825,3.216,1.623a1.568,1.568,0,0,1,.117,1.251c.055.833.887,13.4,1.029,16.163.144,2.82,3.434,15.532,3.467,15.66a.195.195,0,0,1-.175.243l-8.8.612a.194.194,0,0,1-.206-.164c-.686-4.392-1.643-10.387-2.208-13.661.221,4.441.732,13.328.739,13.442a.2.2,0,0,1-.179.205l-7.173.583h-.016m1.418-35.519c-.24,1.311-2.1,11.551-1.96,14.473.137,2.948.663,18.658.73,20.64l6.78-.552c-.1-1.791-.829-14.48-.829-15.661,0-.213.119-.254.19-.259.206-.016.226.1.371.844.081.417.192,1.031.329,1.824.23,1.334.538,3.2.916,5.531.566,3.5,1.122,7.049,1.25,7.87l8.392-.584c-.46-1.786-3.283-12.828-3.42-15.511-.146-2.838-1.022-16.066-1.031-16.2a.2.2,0,0,1,.016-.092,1.158,1.158,0,0,0-.088-.965c-.257-.469-.975-1.1-2.931-1.416a33.434,33.434,0,0,0-8.714.055",
    transform: "translate(-2410.771 -763.957)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M2675.822,600.881s2.832,1.192,3.378,3.627-1.192,5.961-1.539,10.332.96,10.143-2.07,9.447-3.793-1.4-6.475-1.647-3.279,1.043-5.266-.249,2.022-14.462,3.129-16.989a9.234,9.234,0,0,1,5.217-5.067s.1.6,1.192.944a3.646,3.646,0,0,0,2.434-.4",
    transform: "translate(-2426.954 -547.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M2674.083,622.539a2.278,2.278,0,0,1-.509-.062,28.752,28.752,0,0,1-2.9-.834,13.836,13.836,0,0,0-3.554-.809,7.435,7.435,0,0,0-2.417.181,3.257,3.257,0,0,1-2.938-.46c-.937-.609-.829-3.381.321-8.239a69.308,69.308,0,0,1,2.736-8.991,9.344,9.344,0,0,1,5.338-5.176.195.195,0,0,1,.249.154c0,.016.114.49,1.059.791a3.46,3.46,0,0,0,2.28-.383.194.194,0,0,1,.17-.009c.12.05,2.931,1.26,3.493,3.763.315,1.406-.1,3.142-.585,5.154a33.457,33.457,0,0,0-.951,5.237,37.669,37.669,0,0,0-.033,3.8c.062,2.565.115,4.78-.864,5.579a1.382,1.382,0,0,1-.9.3m-7.626-2.126c.219,0,.453.01.7.033a14.331,14.331,0,0,1,3.641.827,28.425,28.425,0,0,0,2.86.824,1.193,1.193,0,0,0,1.076-.163c.831-.679.778-2.908.721-5.268a37.992,37.992,0,0,1,.035-3.842,33.8,33.8,0,0,1,.96-5.3c.472-1.964.879-3.66.584-4.977-.468-2.082-2.722-3.237-3.182-3.452a3.683,3.683,0,0,1-2.5.367,1.994,1.994,0,0,1-1.244-.883,9.24,9.24,0,0,0-4.927,4.9,68.891,68.891,0,0,0-2.714,8.925c-1.507,6.367-.843,7.592-.488,7.823a2.877,2.877,0,0,0,2.647.405,8.456,8.456,0,0,1,1.827-.22",
    transform: "translate(-2424.98 -545.06)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M2658.547,611.317c3.854-1.992,6.656,12.548,1.979,17.216s-16.448-.929-16.448-.929l.389-3.25s9.2,1.412,11.127-.441-.9-10.6,2.952-12.6",
    transform: "translate(-2409.432 -556.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M2706.659,900.844a.2.2,0,0,1-.193-.17l-1.915-15.023a.195.195,0,1,1,.386-.049l1.915,15.024a.2.2,0,0,1-.168.218l-.025,0",
    transform: "translate(-2464.538 -806.854)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M2571.238,744.949a26.244,26.244,0,0,0-3.985-1.717c-.673-.032,1.291,1.589,1.291,1.589s-3.4-.849-3.6-.645,2.543,1.35,2.543,1.35a23.87,23.87,0,0,0-3.907.082c-.1.216,3.789.895,3.789.895s-3.623-.087-3.617.165,3.642.843,3.642.843-3.1.532-2.242.643,5.692-.2,5.692-.2Z",
    transform: "translate(-2336.08 -677.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M2563.8,746.372a6.07,6.07,0,0,1-.67-.026c-.078-.01-.317-.041-.321-.247,0-.146-.006-.286,1.468-.582-2.708-.482-2.712-.69-2.716-.846a.225.225,0,0,1,.068-.167,3.767,3.767,0,0,1,1.6-.209c-1.7-.357-1.781-.505-1.82-.578a.216.216,0,0,1-.005-.192c.055-.12.137-.3,3.072-.225-1.667-.75-1.712-.963-1.731-1.051a.23.23,0,0,1,.058-.208c.075-.079.241-.255,3,.4-.993-.905-.9-1.133-.868-1.228a.3.3,0,0,1,.326-.176,24.273,24.273,0,0,1,4.064,1.738.2.2,0,0,1,.1.2l-.389,3.007a.2.2,0,0,1-.181.169c-.166.011-3.488.222-5.059.222m-1.4-1.648c.671.174,1.9.41,3.031.594a.195.195,0,0,1,0,.384c-.486.083-1.014.185-1.442.28,1.416-.014,4.017-.17,4.686-.211l.351-2.711a27.987,27.987,0,0,0-3.633-1.608,10.022,10.022,0,0,0,1.274,1.219.195.195,0,0,1-.171.339c-1.13-.282-2.371-.55-3.024-.641.473.262,1.326.656,2.094.977a.195.195,0,0,1-.082.374c-1.15-.04-2.391-.054-3.134-.027.718.179,1.929.42,3.056.617a.2.2,0,0,1,.161.211.193.193,0,0,1-.2.176c-1.1-.026-2.3-.02-2.97.026",
    transform: "translate(-2334.08 -675.274)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M2013.315,3091.771l2.116,17.151,8.714-.036s.416-.546-.323-.9c-.527-.251-.978-.211-1.487-.468s-2.852-15.316-2.852-15.316Z",
    transform: "translate(-1834.646 -2817.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M2013.144,3106.856a.223.223,0,0,1-.221-.2l-2.116-17.151a.223.223,0,0,1,.237-.25l6.168.434a.223.223,0,0,1,.2.188c.859,5.519,2.358,14.441,2.769,15.169a2.914,2.914,0,0,0,.659.2,3.447,3.447,0,0,1,.786.246.91.91,0,0,1,.547.586.817.817,0,0,1-.143.647.222.222,0,0,1-.177.088l-8.714.036Zm-1.862-17.133,2.058,16.687,8.385-.035a.316.316,0,0,0,.018-.188c-.034-.132-.185-.228-.305-.286a3.01,3.01,0,0,0-.69-.213,3.22,3.22,0,0,1-.8-.257c-.177-.089-.419-.211-1.736-7.916-.564-3.295-1.085-6.6-1.208-7.39Z",
    transform: "translate(-1832.358 -2815.106)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M2042.54,3251.4l-9.423.043.1-3.442c1.546.144,2.964,1.925,4.526,1.51.9-.233,1.683-1.183,2.545-1.146.065.768.156,1.3.289,1.375.552.307,1.04.266,1.609.563a.732.732,0,0,1,.35,1.1",
    transform: "translate(-1852.69 -2959.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M1875.054,3086.884l-2.7,17.742,8.714-.036s.415-.545-.323-.9c-.527-.251-.977-.211-1.486-.468s1.963-15.907,1.963-15.907Z",
    transform: "translate(-1706.195 -2812.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M1870.067,3102.561a.222.222,0,0,1-.22-.256l2.7-17.742a.225.225,0,0,1,.236-.189l6.168.434a.223.223,0,0,1,.2.257c-.889,5.628-2.2,14.74-2.018,15.7a3.021,3.021,0,0,0,.631.188,3.452,3.452,0,0,1,.786.246.909.909,0,0,1,.547.586.818.818,0,0,1-.143.648.223.223,0,0,1-.177.088l-8.714.036Zm2.889-17.728-2.629,17.281,8.323-.035a.315.315,0,0,0,.018-.188c-.033-.132-.184-.228-.305-.286a3.038,3.038,0,0,0-.69-.213,3.208,3.208,0,0,1-.8-.257c-.227-.114-.461-.232.67-8.279.471-3.348.993-6.71,1.135-7.621Z",
    transform: "translate(-1703.906 -2810.655)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M1877.737,3253.168l-9.423.044.616-3.442c1.546.144,2.451,1.925,4.013,1.51.9-.232,1.99-1.3,2.851-1.264.065.767-.151,1.414-.018,1.493.552.308,1.04.266,1.609.563a.732.732,0,0,1,.35,1.1",
    transform: "translate(-1702.513 -2961.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M1979.05,2536.275a2.979,2.979,0,1,1,2.979,2.945,2.962,2.962,0,0,1-2.979-2.945",
    transform: "translate(-1803.422 -2308.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M1980.041,2537.428a3.138,3.138,0,1,1,3.173-3.138,3.159,3.159,0,0,1-3.173,3.138m0-5.89a2.752,2.752,0,1,0,2.786,2.751,2.771,2.771,0,0,0-2.786-2.751",
    transform: "translate(-1801.434 -2306.528)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M1985.172,2556.726a1.026,1.026,0,1,1,1.006-1.025,1.017,1.017,0,0,1-1.006,1.025m0-1.664a.639.639,0,1,0,.619.639.63.63,0,0,0-.619-.639",
    transform: "translate(-1808.083 -2327.964)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M1862.186,2798.72a14.017,14.017,0,0,1-1.644,4.586c-1.341,2.336-4.326,7.831-5.062,11.422s-2.423,7.831-1.9,9.216.563,1.125,2.12,1.255,2.6-.346,4.586-.044,3.894,1.818,7.182,1.86a34.352,34.352,0,0,0,8.221-1.471l-4.414-26.824a14.789,14.789,0,0,1-4.932.735,22.529,22.529,0,0,1-4.153-.735",
    transform: "translate(-1688.994 -2550.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M1938.911,2629.438a8.678,8.678,0,0,0,4.62.957,19.092,19.092,0,0,0,4.429-.382s.359-4.477.335-5.2,1-2.726.551-4.476c-.5-1.939-1.58-2.083-2.993-4.261-1.177-1.816-1.8-2.873-1.8-2.873a1.628,1.628,0,0,1-1.6.551,12.013,12.013,0,0,1-2.179-.5s-1.7.047-2.346,2.92a13.514,13.514,0,0,0-.048,6.344c.359,2.25,1.029,6.918,1.029,6.918",
    transform: "translate(-1765.582 -2381.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M1941.431,2628.609a8.706,8.706,0,0,1-4.614-.991.194.194,0,0,1-.084-.133c-.007-.047-.674-4.692-1.029-6.916l-.04-.254a13.326,13.326,0,0,1,.091-6.163c.671-2.985,2.454-3.069,2.53-3.071a.228.228,0,0,1,.069.01,11.875,11.875,0,0,0,2.139.493,1.446,1.446,0,0,0,1.419-.466.2.2,0,0,1,.167-.086.2.2,0,0,1,.161.095c.006.011.63,1.076,1.791,2.865a12.029,12.029,0,0,0,1.536,1.9,4.911,4.911,0,0,1,1.481,2.421,6.876,6.876,0,0,1-.324,3.507,4.44,4.44,0,0,0-.22,1.012c.024.721-.321,5.034-.336,5.217a.2.2,0,0,1-.14.171,19.175,19.175,0,0,1-4.48.39h-.115m-4.328-1.27a9.1,9.1,0,0,0,4.44.883,21.712,21.712,0,0,0,4.248-.345c.06-.763.344-4.405.324-5.033a4.442,4.442,0,0,1,.234-1.13,6.567,6.567,0,0,0,.322-3.3,4.544,4.544,0,0,0-1.387-2.252,12.352,12.352,0,0,1-1.581-1.952c-.858-1.324-1.425-2.254-1.667-2.656a1.948,1.948,0,0,1-1.594.421,12.161,12.161,0,0,1-2.18-.5c-.226.024-1.571.271-2.132,2.767a13.02,13.02,0,0,0-.087,6.017l.041.254c.327,2.053.921,6.167,1.017,6.831",
    transform: "translate(-1763.596 -2379.322)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M1882.956,2513.072c.38-.19.058-.9.166-1.11.082-.164,1.074-.416,1.275-.566.14-.106.9-1.016,1.015-1.016.423,0,1.142,1.605,1.2,1.605.126,0,0-.253.024-.377.181-.907.785-1.883.071-2.74-.751-.9-1.517-.109-2.409-.236-.666-.1-1.112-.869-1.771-1.016-1.528-.339-2.574,1.787-3.684,2.527-1.2.8-2.85.858-4.156,1.512a4.739,4.739,0,0,0-1.8,1.464c-1.855,2.886,1.547,2.8,1.157,4.488-.466,2.017-4.7,4.206-1.937,6.47a2.424,2.424,0,0,0,3.283-.165c1.609-1.43,5.837-6.581,6.258-8.691.21-1.051-.445-2.085-.137-2.84s1.138-.356,1.37-.177Z",
    transform: "translate(-1705.129 -2285.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M1980.4,2590.575l-.236,1.438a1.7,1.7,0,0,1-1.214.315,7.677,7.677,0,0,1-1.448-.33l.875-2.272a3.189,3.189,0,0,0,.88.618,2.817,2.817,0,0,0,1.142.231",
    transform: "translate(-1802.007 -2359.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M1977.144,2590.545c-.065,0-.133,0-.2-.009a7.793,7.793,0,0,1-1.492-.34.193.193,0,0,1-.119-.253l.875-2.272a.194.194,0,0,1,.322-.063,3.023,3.023,0,0,0,.821.575,2.628,2.628,0,0,0,1.053.213.187.187,0,0,1,.152.065.193.193,0,0,1,.046.159l-.236,1.438a.2.2,0,0,1-.064.115,1.834,1.834,0,0,1-1.155.371m-1.378-.655a6.838,6.838,0,0,0,1.211.26,1.577,1.577,0,0,0,1.018-.23l.188-1.143a2.872,2.872,0,0,1-1-.242,3.464,3.464,0,0,1-.719-.459Z",
    transform: "translate(-1800.021 -2357.918)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M1959.284,2627.389c4.3-1.468,6.078,9.1,6.078,9.1l-6.313,1.954s-4.07-9.588.234-11.058",
    transform: "translate(-1783.609 -2394.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M2057.622,2734.173a23.533,23.533,0,0,1,4.841-.02,16.35,16.35,0,0,1,3.328,1.953l-6.157.438s-1.415.259-1.773-.021a2.82,2.82,0,0,1-.578-.617Z",
    transform: "translate(-1874.712 -2491.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M2056.559,2734.858a1.414,1.414,0,0,1-.8-.17,3.014,3.014,0,0,1-.622-.665.193.193,0,0,1-.027-.142l.339-1.734a.194.194,0,0,1,.172-.156,23.1,23.1,0,0,1,4.912-.013,16.229,16.229,0,0,1,3.39,1.983.194.194,0,0,1-.1.349l-6.146.437a6.887,6.887,0,0,1-1.113.11m-1.056-.983a2.7,2.7,0,0,0,.491.508,3.363,3.363,0,0,0,1.619-.017l.021,0,5.621-.4a13.159,13.159,0,0,0-2.831-1.612,21.729,21.729,0,0,0-4.626.014Z",
    transform: "translate(-1872.726 -2489.401)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M2083.074,2675.776l5.957-.139,3.925-8.328,5.559.239-4.085,9.105h-11.556Z",
    transform: "translate(-1898.032 -2430.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M2092.445,2674.858h-11.556a.193.193,0,0,1-.188-.237l.2-.877a.193.193,0,0,1,.184-.15l5.838-.136,3.874-8.22a.193.193,0,0,1,.183-.111l5.559.239a.194.194,0,0,1,.168.272l-4.085,9.105a.194.194,0,0,1-.177.114m-11.313-.387h11.188l3.917-8.731-5.146-.221-3.87,8.212a.194.194,0,0,1-.171.111l-5.807.136Z",
    transform: "translate(-1896.046 -2428.613)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M1985.57,2728.246s1.266,4.431,4.659,5.5,13.673-2.1,13.673-2.1a39.593,39.593,0,0,0,3.077-3.78c.195-.552-1.76,1.476-1.76,1.476a19.969,19.969,0,0,0,1.715-2.864c-.127-.152-2.222,2.255-2.222,2.255a12.593,12.593,0,0,0,1.072-2.524,18.549,18.549,0,0,0-2.015,2.523s.275-1.82-.1-1.523-.624,2.057-1.231,2.462-8.939-.051-9.8-.254-2.152-2.709-2.152-2.709Z",
    transform: "translate(-1809.363 -2484.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M1990.093,2732.132a6.6,6.6,0,0,1-1.908-.227c-3.453-1.083-4.734-5.442-4.787-5.627a.194.194,0,0,1,.128-.238l4.912-1.544a.193.193,0,0,1,.23.1c.484.939,1.461,2.477,2.024,2.609.96.226,9.089.616,9.649.281a3.217,3.217,0,0,0,.695-1.376,2.561,2.561,0,0,1,.524-1.076.277.277,0,0,1,.324-.039c.072.042.24.14.179.989,1.5-2.082,1.657-2.029,1.8-1.981a.22.22,0,0,1,.132.125c.026.063.086.209-.463,1.389,1.16-1.265,1.327-1.264,1.4-1.262a.215.215,0,0,1,.163.077c.081.1.169.2-.713,1.6.527-.454.623-.395.712-.34a.244.244,0,0,1,.079.32,36.232,36.232,0,0,1-3.115,3.845.2.2,0,0,1-.087.056c-.359.111-7.621,2.329-11.88,2.329m-6.266-5.781c.28.83,1.6,4.285,4.473,5.185,3.176,1,12.718-1.848,13.507-2.086.754-.845,1.813-2.07,2.453-2.883-.281.267-.6.583-.888.883a.194.194,0,0,1-.3-.243c.484-.712.986-1.487,1.316-2.036-.421.434-.995,1.064-1.517,1.664a.194.194,0,0,1-.318-.216c.313-.611.634-1.277.842-1.756-.389.483-.95,1.24-1.455,1.954a.194.194,0,0,1-.349-.141,7.466,7.466,0,0,0,.094-1.179,6.357,6.357,0,0,0-.284.735,3.264,3.264,0,0,1-.847,1.573c-.72.479-9.2-.048-9.952-.226-.825-.194-1.893-2.084-2.2-2.665Z",
    transform: "translate(-1807.376 -2482.247)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M1914.117,2949.235a6.465,6.465,0,0,1-.795-.046.193.193,0,0,1,.048-.384c2.768.344,7.566-1.431,9.376-4.151a.194.194,0,0,1,.322.215c-1.75,2.63-5.993,4.366-8.951,4.366",
    transform: "translate(-1743.372 -2683.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M1973.927,2991.549a.193.193,0,0,1-.063-.376c2.807-.961,4.135-2.914,5.542-4.981a.194.194,0,0,1,.32.218c-1.444,2.122-2.808,4.126-5.737,5.129a.193.193,0,0,1-.062.01",
    transform: "translate(-1798.576 -2721.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M1899.392,586.709a15.959,15.959,0,1,0-22.118,14.724l.811,9.823h10.7l1.137-9.974a15.952,15.952,0,0,0,9.472-14.572",
    transform: "translate(-1701.748 -520.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M1991.457,1042.667h-10.095a.3.3,0,0,1-.3-.276l-.6-8.086a.3.3,0,0,1,.3-.32h10.7a.3.3,0,0,1,.3.3v8.085a.3.3,0,0,1-.3.3m-9.818-.6h9.521v-7.49H1981.08Z",
    transform: "translate(-1804.708 -942.226)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M1992.944,1056.68h-10.552a.3.3,0,1,1,0-.6h10.552a.3.3,0,1,1,0,.6",
    transform: "translate(-1806.195 -962.363)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M1995.915,1100.787h-10.264a.3.3,0,0,1,0-.6h10.264a.3.3,0,1,1,0,.6",
    transform: "translate(-1809.166 -1002.556)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M1984.382,1077.57a.3.3,0,0,1-.014-.6l10.376-.514a.3.3,0,1,1,.029.595l-10.376.515h-.015",
    transform: "translate(-1808.009 -980.932)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M2021.194,1128.452a2.785,2.785,0,1,1-5.5,0Z",
    transform: "translate(-1836.816 -1028.309)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M1883.994,608.022a.3.3,0,0,1-.116-.572,15.778,15.778,0,1,0-12.6-.142.3.3,0,0,1-.245.543,16.371,16.371,0,1,1,13.074.147.3.3,0,0,1-.116.024",
    transform: "translate(-1696.184 -525.375)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M1969.688,933.379a.3.3,0,0,1-.3-.265l-1.078-9.856a.3.3,0,0,1,.592-.065l1.078,9.856a.3.3,0,0,1-.264.328l-.033,0",
    transform: "translate(-1793.637 -841.024)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M2101.3,934.919l-.033,0a.3.3,0,0,1-.264-.328l1.062-9.706a.3.3,0,1,1,.592.065l-1.062,9.706a.3.3,0,0,1-.3.265",
    transform: "translate(-1914.553 -842.564)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M1987.037,756.306a.3.3,0,0,1-.295-.257,67.72,67.72,0,0,1-.672-7.952c.066-2.584.266-7.589.268-7.64a.3.3,0,0,1,.048-.15,24.3,24.3,0,0,0,2.51-5.281,6.786,6.786,0,0,0-.169-5,1.607,1.607,0,0,0-1.073-.812c-.369-.072-.724.342-.956.7a5.805,5.805,0,0,0-.507,1.014,8.727,8.727,0,0,1,.442,1.655c.257,1.593-.016,2.646-.731,2.816a.63.63,0,0,1-.687-.263c-.483-.683-.219-2.644.343-4.2-.4-.979-.977-1.707-1.574-1.654s-1.192.834-1.6,2.067a9.309,9.309,0,0,1,.459,1.683c.208,1.322-.173,1.747-.529,1.871a.575.575,0,0,1-.621-.137c-.51-.52-.31-2.17.061-3.4-.439-1.1-1.028-2.009-1.35-2.016a.333.333,0,0,0-.266.132c-.552.6-.74,2.873-.455,5.525a8.052,8.052,0,0,0,2.446,4.7.3.3,0,0,1,.1.182c.008.052.759,5.262,1.09,8.18a56.728,56.728,0,0,1,0,7.957.3.3,0,0,1-.594-.04,57.393,57.393,0,0,0,0-7.849c-.3-2.679-.964-7.3-1.073-8.057a8.53,8.53,0,0,1-2.563-5.005c-.247-2.307-.217-5.093.609-5.992a.931.931,0,0,1,.718-.324c.588.013,1.178.82,1.634,1.794.5-1.142,1.156-1.8,1.883-1.861.819-.07,1.469.607,1.934,1.5a5.383,5.383,0,0,1,.332-.6c.6-.931,1.185-1.038,1.57-.964a2.207,2.207,0,0,1,1.47,1.089,7.39,7.39,0,0,1,.23,5.479,24.283,24.283,0,0,1-2.536,5.365c-.026.657-.2,5.151-.264,7.55a68.8,68.8,0,0,0,.667,7.855.3.3,0,0,1-.254.336.29.29,0,0,1-.042,0m-1.161-24.415a5.1,5.1,0,0,0-.176,2.9c.026.036.03.035.063.028.3-.071.483-.891.281-2.142-.042-.263-.1-.529-.168-.789m-3.776.533a3.29,3.29,0,0,0,.007,1.923l.008,0c.15-.052.256-.455.136-1.216a6.933,6.933,0,0,0-.151-.7",
    transform: "translate(-1803.332 -663.951)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M1842.1,965.516a.3.3,0,0,1-.21-.509l4.822-4.79a.3.3,0,0,1,.42.422l-4.822,4.79a.3.3,0,0,1-.21.087",
    transform: "translate(-1678.357 -874.925)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M1759.464,879.269a.3.3,0,0,1-.127-.567l6.731-3.178a.3.3,0,1,1,.254.539l-6.731,3.178a.3.3,0,0,1-.127.029",
    transform: "translate(-1603.05 -797.801)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M1748.207,752.938h-5.726a.3.3,0,1,1,0-.6h5.726a.3.3,0,1,1,0,.6",
    transform: "translate(-1587.575 -685.577)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M1795.252,607.106a.3.3,0,0,1-.137-.034l-5.224-2.712a.3.3,0,1,1,.274-.529l5.224,2.713a.3.3,0,0,1-.137.562",
    transform: "translate(-1630.902 -550.214)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M1946.587,488.323a.3.3,0,0,1-.282-.2l-2.145-6.464a.3.3,0,1,1,.565-.188l2.145,6.464a.3.3,0,0,1-.283.392",
    transform: "translate(-1771.614 -438.555)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M2107.286,470.346a.3.3,0,0,1-.287-.379l1.784-6.329a.3.3,0,0,1,.573.162l-1.784,6.329a.3.3,0,0,1-.286.217",
    transform: "translate(-1920.005 -422.295)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M2217.952,564.664a.3.3,0,0,1-.22-.5l4.019-4.42a.3.3,0,0,1,.441.4l-4.019,4.42a.3.3,0,0,1-.22.1",
    transform: "translate(-2020.851 -509.983)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M2263.235,706.519a.3.3,0,0,1-.048-.592l6.631-1.079a.3.3,0,1,1,.1.588l-6.631,1.079a.3.3,0,0,1-.048,0",
    transform: "translate(-2062.115 -642.294)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M2269.866,821.316a.306.306,0,0,1-.056-.005l-6.631-1.268a.3.3,0,0,1,.112-.585l6.631,1.268a.3.3,0,0,1-.056.591",
    transform: "translate(-2062.116 -746.731)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M2232.507,890.767a.3.3,0,0,1-.134-.032l-6.631-3.355a.3.3,0,0,1,.269-.532l6.631,3.355a.3.3,0,0,1-.135.564",
    transform: "translate(-2028.072 -808.117)",
    fill: "#120610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M2166.955,949.545a.3.3,0,0,1-.277-.187l-2.21-5.529a.3.3,0,1,1,.553-.221l2.21,5.529a.3.3,0,0,1-.166.387.3.3,0,0,1-.11.021",
    transform: "translate(-1972.365 -859.698)",
    fill: "#120610"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGetintouch);
export default __webpack_public_path__ + "static/media/icon_getintouch.d27599ee8dabd189f16fdea852189bb0.svg";
export { ForwardRef as ReactComponent };